/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUsersWorkspace = /* GraphQL */ `
  query GetUsersWorkspace($id: ID) {
    getUsersWorkspace(id: $id) {
      id
      username
      user_email
    }
  }
`;
export const getPlanWorkspace = /* GraphQL */ `
  query GetPlanWorkspace($id: ID) {
    getPlanWorkspace(id: $id) {
      id
      type
      subscriptionStatus
      isPredictionOnDemandGlobal
      isTrainingOnDemandGlobal
      predictionRequestsGlobal
      batchRequestsGlobal
      trainingMinutesGlobal
      baseModelGN
      baseModelQA
      baseModelNLP
      maxUsers
      maxPowerUsers
      agcEnabled
      isDownloadModelEnabled
      isDownloadDataEnabled
      isAPIAccessEnabled
      isBatchJobsEnabled
      isSentimentReviewerEnabled
      isBusinessAnalystEnabled
      isContentCreatorEnabled
      isPriorityTrainingEnabled
      isPredictionGPUAccelerationEnabledGlobal
      isPredictionGPUAccelerationEnabledRC
      isPredictionGPUAccelerationEnabledNLP
      aiMaxConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      maxMrcDocs
      maxAgents
      maxSites
      maxBenchmarks
      predictionRequestsAPI
      accuracyModelEnabled
      isTrainingNLPEnabled
      isTrainingQAEnabled
      isTrainingGNEnabled
      isLongTermMemoryEnabled
      isFunctionsEnabled
      isDBFunctionsEnabled
      isHtmlFunctionsEnabled
      isSitesBindingEnabled
      isAgentsSecurityEnabled
      isWidgetChatsHistoryEnabled
      maxRequests30Minutes
      maxRequests24Hours
      defaultSupportHours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const getUserIDByEmail = /* GraphQL */ `
  query GetUserIDByEmail($email: String!) {
    getUserIDByEmail(email: $email) {
      id
      username
      user_email
    }
  }
`;
export const getDocumentsWorkspace = /* GraphQL */ `
  query GetDocumentsWorkspace($id: ID!, $limit: Int, $nextToken: String) {
    getDocumentsWorkspace(id: $id, limit: $limit, nextToken: $nextToken) {
      id
      embedding_status
      completion_percentage
    }
  }
`;
export const getTokenByAgent = /* GraphQL */ `
  query GetTokenByAgent($id: ID!) {
    getTokenByAgent(id: $id)
  }
`;
export const getSSOproviderByDomain = /* GraphQL */ `
  query GetSSOproviderByDomain($domain: String!) {
    getSSOproviderByDomain(domain: $domain)
  }
`;
export const getAppConfig = /* GraphQL */ `
  query GetAppConfig($id: ID!) {
    getAppConfig(id: $id) {
      id
      saveTimer
      screenResponsiveWidth
      mobileResponsiveWidth
      veryLargeScreenResponsiveWidth
      chartMaxHeight
      inactiveTimeout
      sideMenuWidth
      availableLanguages
      baseIntents
      baseEntities
      baseTopics
      supportDomain
      metadata
      announcement
      lastAnnouncementInt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listAppConfigs = /* GraphQL */ `
  query ListAppConfigs(
    $filter: ModelAppConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppConfigs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        saveTimer
        screenResponsiveWidth
        mobileResponsiveWidth
        veryLargeScreenResponsiveWidth
        chartMaxHeight
        inactiveTimeout
        sideMenuWidth
        availableLanguages
        baseIntents
        baseEntities
        baseTopics
        supportDomain
        metadata
        announcement
        lastAnnouncementInt
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncAppConfigs = /* GraphQL */ `
  query SyncAppConfigs(
    $filter: ModelAppConfigFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAppConfigs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        saveTimer
        screenResponsiveWidth
        mobileResponsiveWidth
        veryLargeScreenResponsiveWidth
        chartMaxHeight
        inactiveTimeout
        sideMenuWidth
        availableLanguages
        baseIntents
        baseEntities
        baseTopics
        supportDomain
        metadata
        announcement
        lastAnnouncementInt
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      owner
      username
      user_email
      user_email_verified
      user_phone_number
      timezone
      language
      isSentenceSplitEnabled
      isImplicitSelfEnabled
      replyLanguage
      theme
      user_phone_number_verified
      userInstructions
      userMemories
      isOnboarded
      userHelperPreferences
      type
      sourceCode
      referralCode
      referredBy
      couponCode
      image
      workspaces {
        items {
          id
          owner
          title
          visibility
          userID
          isMed
          type
          usagePlanID
          workspaceTokenID
          workspaceToken
          subscriptionType
          subscriptionId
          subscriptionStatus
          enableExperimentalFeatures
          utilityEndpoint
          utilityUrl
          utilityUrlStatus
          utilityUrlType
          utilityBaseModel
          utilityProvider
          codingEndpoint
          codingUrl
          codingUrlStatus
          codingUrlType
          codingBaseModel
          codingProvider
          generalPurposeEndpoint
          generalPurposeUrl
          generalPurposeUrlStatus
          generalPurposeUrlType
          generalPurposeBaseModel
          generalPurposeProvider
          qaEnpoint
          qaUrl
          qaUrlStatus
          qaUrlType
          qaBaseModel
          qaProvider
          cnEndpoint
          cnUrl
          cnUrlStatus
          cnUrlType
          cnBaseModel
          cnProvider
          gnEnpoint
          gnUrl
          gnUrlStatus
          gnUrlType
          gnBaseModel
          gnProvider
          nlpEnpoint
          nlpUrl
          nlpUrlStatus
          nlpUrlType
          nlpBaseModel
          nlpProvider
          embeddingEndpoint
          embeddingUrl
          embeddingUrlStatus
          embeddingUrlType
          embeddingBaseModel
          embeddingProvider
          chartingEndpoint
          chartingUrl
          chartingUrlStatus
          chartingUrlType
          chartingBaseModel
          chartingProvider
          imagingEndpoint
          imagingUrl
          imagingUrlStatus
          imagingUrlType
          imagingBaseModel
          imagingProvider
          reasoningEndpoint
          reasoningUrl
          reasoningUrlStatus
          reasoningUrlType
          reasoningBaseModel
          reasoningProvider
          defaultChatVisibility
          billingStatus
          lastBillingDate
          lastConsumptionNotificationDate
          activeUntil
          paymentFailed
          bulkImportAllowed
          lastPaymentAttempt
          targetSubscriptionType
          lastChangeSubscriptionDate
          maxUsers
          minUsers
          contractStartDate
          xeroId
          xeroContactId
          xeroInvoiceId
          lastXeroBillingDate
          billingProvider
          supportHours
          supportHoursUsed
          reservedComputeAllocation
          baseModel
          domain
          customImageRecognitionModel
          customVectorDB
          customUoiPrice
          disabled
          users
          userCognitoIds
          workspaceCreationDate
          workspaceModelReady
          enableDeleteFunctionInAgents
          enableUpdateFunctionInAgents
          enableCustomFunctionInAgents
          defaultChatAgent
          defaultBusinessAnalystAgent
          defaultContentCreatorAgent
          isSentimentReviewerEnabled
          isExtendedContentCreatorEnabled
          isExtendedBusinessAnalystReportEnabled
          customIndexedDBendpoint
          createdBy
          updatedBy
          federationMetadataUrl
          federationMetadataUrlStatus
          federationMetadataUrlType
          ssoType
          ssoDomain
          ssoProviderName
          isMultiLanguageEnabled
          customChartingConfig
          twilioConfig
          emailConfig
          isMFAEnabled
          advancedVectorisation
          advancedCompute
          enableAutoInvite
          autoInviteDomain
          autoInviteUserRole
          customMaxPowerUsers
          customUoiBudget
          requestsPer30MinutesFactor
          webhookUrl
          webhookAuthorisationType
          webhookAuthorisationID
          logo
          enforceRegionalModels
          blockedModels
          billingPeriodStart
          billingPeriodEnd
          parentWorkspaceID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cognitoUsername
      stripeCustomerId
      subscribedToNewsletter
      newsletterConsentedAt
      newsletterConsentMethod
      newsletterConsentTermsVersion
      newsletterPromptShown
      newsletterSubscriptionStatus
      newsletterUpdatedAt
      isLead
      stripePaymentIntentId
      maximumNumberOfWorkspaces
      workspacesAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          favoriteAgents
          recentLocalFolders
          recentFiles
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      lastViewedReleaseVersion
      isMFAEnabled
      desktopAppInstalled
      lastAnnouncementViewedInt
      expoPushTokens
      enableExperimentalFeatures
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        username
        user_email
        user_email_verified
        user_phone_number
        timezone
        language
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        replyLanguage
        theme
        user_phone_number_verified
        userInstructions
        userMemories
        isOnboarded
        userHelperPreferences
        type
        sourceCode
        referralCode
        referredBy
        couponCode
        image
        workspaces {
          nextToken
          startedAt
        }
        cognitoUsername
        stripeCustomerId
        subscribedToNewsletter
        newsletterConsentedAt
        newsletterConsentMethod
        newsletterConsentTermsVersion
        newsletterPromptShown
        newsletterSubscriptionStatus
        newsletterUpdatedAt
        isLead
        stripePaymentIntentId
        maximumNumberOfWorkspaces
        workspacesAccessLevel {
          nextToken
          startedAt
        }
        lastViewedReleaseVersion
        isMFAEnabled
        desktopAppInstalled
        lastAnnouncementViewedInt
        expoPushTokens
        enableExperimentalFeatures
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncUsers = /* GraphQL */ `
  query SyncUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUsers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        owner
        username
        user_email
        user_email_verified
        user_phone_number
        timezone
        language
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        replyLanguage
        theme
        user_phone_number_verified
        userInstructions
        userMemories
        isOnboarded
        userHelperPreferences
        type
        sourceCode
        referralCode
        referredBy
        couponCode
        image
        workspaces {
          nextToken
          startedAt
        }
        cognitoUsername
        stripeCustomerId
        subscribedToNewsletter
        newsletterConsentedAt
        newsletterConsentMethod
        newsletterConsentTermsVersion
        newsletterPromptShown
        newsletterSubscriptionStatus
        newsletterUpdatedAt
        isLead
        stripePaymentIntentId
        maximumNumberOfWorkspaces
        workspacesAccessLevel {
          nextToken
          startedAt
        }
        lastViewedReleaseVersion
        isMFAEnabled
        desktopAppInstalled
        lastAnnouncementViewedInt
        expoPushTokens
        enableExperimentalFeatures
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const usersByOwner = /* GraphQL */ `
  query UsersByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        username
        user_email
        user_email_verified
        user_phone_number
        timezone
        language
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        replyLanguage
        theme
        user_phone_number_verified
        userInstructions
        userMemories
        isOnboarded
        userHelperPreferences
        type
        sourceCode
        referralCode
        referredBy
        couponCode
        image
        workspaces {
          nextToken
          startedAt
        }
        cognitoUsername
        stripeCustomerId
        subscribedToNewsletter
        newsletterConsentedAt
        newsletterConsentMethod
        newsletterConsentTermsVersion
        newsletterPromptShown
        newsletterSubscriptionStatus
        newsletterUpdatedAt
        isLead
        stripePaymentIntentId
        maximumNumberOfWorkspaces
        workspacesAccessLevel {
          nextToken
          startedAt
        }
        lastViewedReleaseVersion
        isMFAEnabled
        desktopAppInstalled
        lastAnnouncementViewedInt
        expoPushTokens
        enableExperimentalFeatures
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const usersByEmail = /* GraphQL */ `
  query UsersByEmail(
    $user_email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByEmail(
      user_email: $user_email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        username
        user_email
        user_email_verified
        user_phone_number
        timezone
        language
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        replyLanguage
        theme
        user_phone_number_verified
        userInstructions
        userMemories
        isOnboarded
        userHelperPreferences
        type
        sourceCode
        referralCode
        referredBy
        couponCode
        image
        workspaces {
          nextToken
          startedAt
        }
        cognitoUsername
        stripeCustomerId
        subscribedToNewsletter
        newsletterConsentedAt
        newsletterConsentMethod
        newsletterConsentTermsVersion
        newsletterPromptShown
        newsletterSubscriptionStatus
        newsletterUpdatedAt
        isLead
        stripePaymentIntentId
        maximumNumberOfWorkspaces
        workspacesAccessLevel {
          nextToken
          startedAt
        }
        lastViewedReleaseVersion
        isMFAEnabled
        desktopAppInstalled
        lastAnnouncementViewedInt
        expoPushTokens
        enableExperimentalFeatures
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const usersByStripeCustomerID = /* GraphQL */ `
  query UsersByStripeCustomerID(
    $stripeCustomerId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByStripeCustomerID(
      stripeCustomerId: $stripeCustomerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        username
        user_email
        user_email_verified
        user_phone_number
        timezone
        language
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        replyLanguage
        theme
        user_phone_number_verified
        userInstructions
        userMemories
        isOnboarded
        userHelperPreferences
        type
        sourceCode
        referralCode
        referredBy
        couponCode
        image
        workspaces {
          nextToken
          startedAt
        }
        cognitoUsername
        stripeCustomerId
        subscribedToNewsletter
        newsletterConsentedAt
        newsletterConsentMethod
        newsletterConsentTermsVersion
        newsletterPromptShown
        newsletterSubscriptionStatus
        newsletterUpdatedAt
        isLead
        stripePaymentIntentId
        maximumNumberOfWorkspaces
        workspacesAccessLevel {
          nextToken
          startedAt
        }
        lastViewedReleaseVersion
        isMFAEnabled
        desktopAppInstalled
        lastAnnouncementViewedInt
        expoPushTokens
        enableExperimentalFeatures
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getWorkspace = /* GraphQL */ `
  query GetWorkspace($id: ID!) {
    getWorkspace(id: $id) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      defaultChatVisibility
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      minUsers
      contractStartDate
      xeroId
      xeroContactId
      xeroInvoiceId
      lastXeroBillingDate
      billingProvider
      supportHours
      supportHoursUsed
      reservedComputeAllocation
      baseModel
      domain
      trainingConfig {
        trainingIterations
        trainingIterationsNLP
        trainingIterationsRC
        trainingEpochsNLP
        trainingEpochsRC
        trainingEpochsGN
        maxStepsNLP
        patienceNLP
        learningRateNLP
        learningRateRC
        testSizeNLP
        testSizeRC
        batchSizeNLP
        batchSizeRC
        datasetTestSizeThresholdNLP
        datasetTestSizeThresholdRC
        learningRateGN
        testSizeGN
        batchSizeGN
        datasetTestSizeThresholdGN
        enableManagedSpotTraining
        maxRuntimeWaitTime
        maxRuntime
        includeReadComprehensionDataInTraining
        generateDockerImageForRCengine
        generateDockerImageForNLPengine
        generateDockerImageForGNengine
        emailsListForTrainingConfirmation
        maxQueueWaitTime
      }
      parsingConfig {
        questionsLimit
        answerAsNER
        answerByParagraph
        uniqueAnswer
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        temperature
        maxTokens
        topP
        topK
        qaDocTopK
        frequencyPenalty
        presencePenalty
        qaTopP
        qaTopK
        qaMaxTokens
        qaTemperature
        qaFrequencyPenalty
        qaPresencePenalty
        qaReplyOutsidePassage
        qaAiKnowledge
        qaInhibitionPassage
        qaEnhancementPassage
        qaRole
        qaDefaultAnswer
        qaStopSequence
        stopSequence
        stopPrompt
        qaExamples {
          question
          answer
        }
        qaBlender
        agcEnabled
      }
      notificationConfig {
        emailsList
        emailOnTrainingCompleted
        emailOnBatchCompleted
        emailOnBatchFailed
        emailOnBatchStart
        emailOnTrainingFailed
        emailOnTrainingStart
        notifyAllUsersInWorkspace
        notifyOnThreasholdConsumption
        notificationThresholdConsumption
      }
      embeddingConfig {
        maxChunkWords
        maxOverlapSentences
        chunkingStrategy
        imageExtractionStrategy
        minImageWidth
        minImageHeight
        aspectRatioMin
        aspectRatioMax
      }
      customGenerationConfig {
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        hasTopicsContext
        topics
        docTopK
        topK
        blender
        mode
        aiKnowledge
        compressor
      }
      customImageRecognitionModel
      customVectorDB
      workspaceAgents {
        items {
          id
          type
          label
          description
          interpolationString
          emoji
          color
          darkColor
          icon
          largeLogo
          icoUrl
          logoBackground
          darkLogoBackground
          messageOnLaunch
          messagesOnLaunch
          rotateMessagesOnLaunch
          rotateMessagesOnLaunchInterval
          placeholderMessageOnLoading
          dynamicPlaceholderMessageOnLoading
          customGreetingInstructions
          customConclusionInstructions
          customChartingInstructions
          customSummarisationInstructions
          customImagesInstructions
          customToolingInstructions
          placeholderInputMessage
          openByDefault
          agenticCodingModel
          disclaimer
          showDocumentsReferences
          isDefault
          hasMemory
          hasImages
          promptTopKeywords
          keyWordsForKnowledgeBase
          hasTopicsContext
          hasFunctions
          advancedLanguageDetection
          allowedTopics
          staticDocs
          defaultAnswer
          noKnowledgeDefaultAnswer
          quickQuestions
          recencyImportance
          maxRecencyIncrease
          recencyTopKIncreaseFactor
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          showCodeInExecution
          hideReasoning
          charting
          summarisation
          compressor
          docTopK
          minRetrievalScore
          timeSignificance
          hasModeration
          customModerations
          moderationMessage
          languageDetectionConfidence
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          seed
          version
          subject
          workspaceID
          createdBy
          updatedBy
          agentFunctions
          isGlobal
          promptBuffering
          functionContext
          plainTextOutput
          chainOfThoughts
          treeOfThoughts
          extendedOutput
          agentType
          agentsPool
          mcps
          maxPlanningSteps
          maxBrowserSteps
          virtualDesktopInstructions
          planningInstructions
          plannerExecutionAttempts
          plannerRequiresApprovalForPlanExecution
          plannerEmailOnApprovalRequest
          plannerEmailOnFailedPlan
          plannerEmailOnCompletedPlan
          plannerAutoAgentSpawn
          plannerRetainsSpawnedAgents
          plannerPromptsAgentsProgrammatically
          plannerDeepThinking
          allowReplanning
          plannerProceedsWhenImprovementsRequired
          plannerApproverEmails
          reviewInstructions
          showReferencesToInternalDocs
          showCitations
          forceJsonOutput
          agenticRAG
          preventWidgetUsage
          allowFeedback
          generateExtendedReport
          showTimeForResponse
          showDetectedLanguage
          showRoutedModel
          isMultiLanguageEnabled
          hasMath
          hasCode
          hasComputer
          hasNER
          restrictedAccess
          restrictedAccessUsers
          splashTitle
          showSplashWhenEmpty
          llmEndpoint
          llmUrl
          llmUrlStatus
          llmUrlType
          llmBaseModel
          llmProvider
          llmTopK
          llmSeed
          forcedTheme
          adverserialProvider
          adverserialModel
          functionCallingProvider
          functionCallingModel
          visionProvider
          visionModel
          browserProvider
          browserModel
          videoGenerationProvider
          videoGenerationModel
          showAgentName
          allowImagesUpload
          allowVideosUpload
          allowAudiosUpload
          allowDocsUpload
          allowImagesGeneration
          baseImageGenerationModel
          maxImagesGenerated
          advancedImageGeneration
          allowVideosGeneration
          allowAudiosGeneration
          allowIntrospection
          voiceFileKey
          audiosGenerationTtsModel
          audiosGenerationVoiceName
          audiosGenerationSpeechMode
          allowInternetSearch
          bannedDomains
          maxUrlsForInternetSearch
          allowDeepInternetSearch
          internetSearchModes
          internetSearchLocation
          autoVoiceMode
          voiceSensitivity
          keywordsWeightInRetrieval
          customCodeExecutionEnvironments
          phoneNumberAsSender
          whatsappNumberAsSender
          emailAsSender
          communicationServices
          channelCallbackDelay
          ephemeralAgent
          parentAgentID
          parentChatID
          minimumSubscriptionType
          clonedAgentID
          clonedAgentIDIcon
          hasContentCreation
          hasEntityExtraction
          department
          metadata
          allowEmailToAgent
          allowedEmails
          agentHiringTemplate
          agentDesktopVM
          agentDesktopPortRange
          agentDesktopCredentials
          agentDesktopBrowser
          allow3dModelGeneration
          agentLongTermMemory
          isLongTermMemoryEnabled
          allowExternalAPI
          forceNewThreadOnProgrammaticRequest
          dynamicModelSelectionInstructions
          contextRelevancyRatio
          reasoningBudget
          reasoningMode
          reasoningEffort
          fnReasoningEffort
          agentFnParams
          canvasEnabled
          advancedCompute
          reRank
          minDeepSearchPagesPercentage
          voiceName
          vadThresholds
          analyticsInstructions
          analyticsCustomFields
          alertIDs
          ragInstructions
          allowAskQuestion
          ragSearchStrategy
          minChunksBeforeCompleteness
          ragCompletenessThreshold
          voiceInstructions
          sttModel
          llmVoiceModel
          ttsModel
          defaultVoiceLanguage
          voiceMinSilenceDuration
          voiceMinEndpointingDelay
          voiceMinInterruptionDuration
          enableVoiceIntermissions
          voiceBackgroundNoise
          sipPhoneNumber
          sipDispatchRuleId
          enableInboundSip
          enableOutboundSip
          enableJsonOutput
          jsonOutputStructure
          predictedPlanJson
          useInterleavedReasoning
          interleavedPreset
          maxTotalToolCalls
          maxConsecutiveSameTool
          maxConsecutiveFailures
          regionalEndpoint
          agentVersion
          agentCategoryType
          maxSessionUoI
          maxSessionTurns
          maxSessionMessage
          showWidgetControls
          allowIpRotationViaProxy
          showToolCallsDetailsInWidget
          allowProxyScraping
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCustomPrompts {
        items {
          id
          type
          scope
          style
          domain
          label
          promptLength
          promptPlaceholder
          interpolationString
          availableToAgents
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customQaConfig {
        roles {
          type
          label
          description
          interpolationString
          emoji
          color
          isDefault
          hasMemory
          hasTopicsContext
          allowedTopics
          defaultAnswer
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          charting
          summarisation
          compressor
          docTopK
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
        }
      }
      aiConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      aggregatedConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      customUoiPrice
      disabled
      subscriptionPricingPlan {
        items {
          id
          type
          subscriptionStatus
          isPredictionOnDemandGlobal
          isTrainingOnDemandGlobal
          predictionRequestsGlobal
          batchRequestsGlobal
          trainingMinutesGlobal
          baseModelGN
          baseModelQA
          baseModelNLP
          maxUsers
          maxPowerUsers
          agcEnabled
          isDownloadModelEnabled
          isDownloadDataEnabled
          isAPIAccessEnabled
          isBatchJobsEnabled
          isSentimentReviewerEnabled
          isBusinessAnalystEnabled
          isContentCreatorEnabled
          isPriorityTrainingEnabled
          isPredictionGPUAccelerationEnabledGlobal
          isPredictionGPUAccelerationEnabledRC
          isPredictionGPUAccelerationEnabledNLP
          maxMrcDocs
          maxAgents
          maxSites
          maxBenchmarks
          predictionRequestsAPI
          accuracyModelEnabled
          isTrainingNLPEnabled
          isTrainingQAEnabled
          isTrainingGNEnabled
          isLongTermMemoryEnabled
          isFunctionsEnabled
          isDBFunctionsEnabled
          isHtmlFunctionsEnabled
          isSitesBindingEnabled
          isAgentsSecurityEnabled
          isWidgetChatsHistoryEnabled
          maxRequests30Minutes
          maxRequests24Hours
          defaultSupportHours
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      folders {
        items {
          id
          owner
          name
          description
          emoji
          status
          allowedTopics
          parent
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          name
          description
          status
          trainingIterations
          lastActivation
          duration
          trainingMeta
          trainingConfig
          workspaceID
          type
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      entities {
        items {
          id
          owner
          label
          type
          description
          emoji
          parentEntity
          backgroundColor
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      appLogs {
        items {
          id
          owner
          type
          filename
          event
          status
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      batchJobs {
        items {
          id
          owner
          name
          description
          status
          duration
          batchMeta
          batchConfig
          batchOutput
          workspaceID
          type
          createdBy
          updatedBy
          benchmarkID
          agentID
          agentVersion
          reviewerAgentID
          reviewerAgentVersion
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      dictionaryItems {
        items {
          id
          owner
          sourceLanguage
          targetLanguage
          sourceText
          targetText
          workspaceID
          pos
          description
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      requestsLogs {
        items {
          id
          srtKey
          type
          status
          words
          tokens
          sentences
          artifactsNumber
          modelType
          outputType
          inputTokens
          outputTokens
          totalTokens
          inputCostUSD
          outputCostUSD
          description
          totalCostUSD
          cachedInputTokens
          cacheHitRate
          cacheSavingsUSD
          callType
          callPurpose
          latencyMs
          agentID
          workspaceID
          createdBy
          updatedBy
          creationTime
          isFromToothFairy
          userID
          supportHours
          chatID
          messageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      communicationServices {
        items {
          id
          workspaceID
          name
          description
          channel
          provider
          senderid
          fromNumber
          tokenSecret
          sipTrunkId
          isActive
          config
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      sites {
        items {
          id
          name
          description
          url
          customSitemap
          workspaceID
          topics
          status
          lastValidationDate
          lastValidationRequested
          validationToken
          allowedPaths
          siteTree
          lastScraped
          skipOwnerValidation
          useProxy
          completion_percentage
          extractImages
          freeRoaming
          scrapingCycle
          imgRetrievalPrompt
          metadata
          createdBy
          updatedBy
          scapablePages
          scrapedPagesCount
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cronJobs {
        items {
          id
          name
          description
          forcedPrompt
          type
          agentID
          customPromptID
          workspaceID
          timezone
          isActive
          lastRunAt
          nextRunAt
          status
          metadata
          startDate
          endDate
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customExecutionEnvironments {
        items {
          id
          name
          description
          functionName
          availableLibraries
          ip
          workspaceID
          port
          metadata
          createdBy
          updatedBy
          isGlobal
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      users
      userCognitoIds
      usersAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          favoriteAgents
          recentLocalFolders
          recentFiles
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      isMFAEnabled
      advancedVectorisation
      advancedCompute
      enableAutoInvite
      autoInviteDomain
      autoInviteUserRole
      customMaxPowerUsers
      customUoiBudget
      requestsPer30MinutesFactor
      webhookUrl
      webhookAuthorisationType
      webhookAuthorisationID
      logo
      enforceRegionalModels
      blockedModels
      billingPeriodStart
      billingPeriodEnd
      parentWorkspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listWorkspaces = /* GraphQL */ `
  query ListWorkspaces(
    $filter: ModelWorkspaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkspaces(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        title
        visibility
        userID
        isMed
        type
        usagePlanID
        workspaceTokenID
        workspaceToken
        subscriptionType
        subscriptionId
        subscriptionStatus
        enableExperimentalFeatures
        utilityEndpoint
        utilityUrl
        utilityUrlStatus
        utilityUrlType
        utilityBaseModel
        utilityProvider
        codingEndpoint
        codingUrl
        codingUrlStatus
        codingUrlType
        codingBaseModel
        codingProvider
        generalPurposeEndpoint
        generalPurposeUrl
        generalPurposeUrlStatus
        generalPurposeUrlType
        generalPurposeBaseModel
        generalPurposeProvider
        qaEnpoint
        qaUrl
        qaUrlStatus
        qaUrlType
        qaBaseModel
        qaProvider
        cnEndpoint
        cnUrl
        cnUrlStatus
        cnUrlType
        cnBaseModel
        cnProvider
        gnEnpoint
        gnUrl
        gnUrlStatus
        gnUrlType
        gnBaseModel
        gnProvider
        nlpEnpoint
        nlpUrl
        nlpUrlStatus
        nlpUrlType
        nlpBaseModel
        nlpProvider
        embeddingEndpoint
        embeddingUrl
        embeddingUrlStatus
        embeddingUrlType
        embeddingBaseModel
        embeddingProvider
        chartingEndpoint
        chartingUrl
        chartingUrlStatus
        chartingUrlType
        chartingBaseModel
        chartingProvider
        imagingEndpoint
        imagingUrl
        imagingUrlStatus
        imagingUrlType
        imagingBaseModel
        imagingProvider
        reasoningEndpoint
        reasoningUrl
        reasoningUrlStatus
        reasoningUrlType
        reasoningBaseModel
        reasoningProvider
        defaultChatVisibility
        billingStatus
        lastBillingDate
        lastConsumptionNotificationDate
        activeUntil
        paymentFailed
        bulkImportAllowed
        lastPaymentAttempt
        targetSubscriptionType
        lastChangeSubscriptionDate
        maxUsers
        minUsers
        contractStartDate
        xeroId
        xeroContactId
        xeroInvoiceId
        lastXeroBillingDate
        billingProvider
        supportHours
        supportHoursUsed
        reservedComputeAllocation
        baseModel
        domain
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        embeddingConfig {
          maxChunkWords
          maxOverlapSentences
          chunkingStrategy
          imageExtractionStrategy
          minImageWidth
          minImageHeight
          aspectRatioMin
          aspectRatioMax
        }
        customGenerationConfig {
          styles
          domains
          scopes
          hasTopicsContext
          topics
          docTopK
          topK
          blender
          mode
          aiKnowledge
          compressor
        }
        customImageRecognitionModel
        customVectorDB
        workspaceAgents {
          nextToken
          startedAt
        }
        workspaceCustomPrompts {
          nextToken
          startedAt
        }
        aiConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        aggregatedConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        customUoiPrice
        disabled
        subscriptionPricingPlan {
          nextToken
          startedAt
        }
        folders {
          nextToken
          startedAt
        }
        trainingLogs {
          nextToken
          startedAt
        }
        entities {
          nextToken
          startedAt
        }
        appLogs {
          nextToken
          startedAt
        }
        batchJobs {
          nextToken
          startedAt
        }
        dictionaryItems {
          nextToken
          startedAt
        }
        requestsLogs {
          nextToken
          startedAt
        }
        communicationServices {
          nextToken
          startedAt
        }
        sites {
          nextToken
          startedAt
        }
        cronJobs {
          nextToken
          startedAt
        }
        customExecutionEnvironments {
          nextToken
          startedAt
        }
        users
        userCognitoIds
        usersAccessLevel {
          nextToken
          startedAt
        }
        workspaceCreationDate
        workspaceModelReady
        enableDeleteFunctionInAgents
        enableUpdateFunctionInAgents
        enableCustomFunctionInAgents
        defaultChatAgent
        defaultBusinessAnalystAgent
        defaultContentCreatorAgent
        isSentimentReviewerEnabled
        isExtendedContentCreatorEnabled
        isExtendedBusinessAnalystReportEnabled
        customIndexedDBendpoint
        createdBy
        updatedBy
        federationMetadataUrl
        federationMetadataUrlStatus
        federationMetadataUrlType
        ssoType
        ssoDomain
        ssoProviderName
        isMultiLanguageEnabled
        customChartingConfig
        twilioConfig
        emailConfig
        isMFAEnabled
        advancedVectorisation
        advancedCompute
        enableAutoInvite
        autoInviteDomain
        autoInviteUserRole
        customMaxPowerUsers
        customUoiBudget
        requestsPer30MinutesFactor
        webhookUrl
        webhookAuthorisationType
        webhookAuthorisationID
        logo
        enforceRegionalModels
        blockedModels
        billingPeriodStart
        billingPeriodEnd
        parentWorkspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncWorkspaces = /* GraphQL */ `
  query SyncWorkspaces(
    $filter: ModelWorkspaceFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncWorkspaces(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        owner
        title
        visibility
        userID
        isMed
        type
        usagePlanID
        workspaceTokenID
        workspaceToken
        subscriptionType
        subscriptionId
        subscriptionStatus
        enableExperimentalFeatures
        utilityEndpoint
        utilityUrl
        utilityUrlStatus
        utilityUrlType
        utilityBaseModel
        utilityProvider
        codingEndpoint
        codingUrl
        codingUrlStatus
        codingUrlType
        codingBaseModel
        codingProvider
        generalPurposeEndpoint
        generalPurposeUrl
        generalPurposeUrlStatus
        generalPurposeUrlType
        generalPurposeBaseModel
        generalPurposeProvider
        qaEnpoint
        qaUrl
        qaUrlStatus
        qaUrlType
        qaBaseModel
        qaProvider
        cnEndpoint
        cnUrl
        cnUrlStatus
        cnUrlType
        cnBaseModel
        cnProvider
        gnEnpoint
        gnUrl
        gnUrlStatus
        gnUrlType
        gnBaseModel
        gnProvider
        nlpEnpoint
        nlpUrl
        nlpUrlStatus
        nlpUrlType
        nlpBaseModel
        nlpProvider
        embeddingEndpoint
        embeddingUrl
        embeddingUrlStatus
        embeddingUrlType
        embeddingBaseModel
        embeddingProvider
        chartingEndpoint
        chartingUrl
        chartingUrlStatus
        chartingUrlType
        chartingBaseModel
        chartingProvider
        imagingEndpoint
        imagingUrl
        imagingUrlStatus
        imagingUrlType
        imagingBaseModel
        imagingProvider
        reasoningEndpoint
        reasoningUrl
        reasoningUrlStatus
        reasoningUrlType
        reasoningBaseModel
        reasoningProvider
        defaultChatVisibility
        billingStatus
        lastBillingDate
        lastConsumptionNotificationDate
        activeUntil
        paymentFailed
        bulkImportAllowed
        lastPaymentAttempt
        targetSubscriptionType
        lastChangeSubscriptionDate
        maxUsers
        minUsers
        contractStartDate
        xeroId
        xeroContactId
        xeroInvoiceId
        lastXeroBillingDate
        billingProvider
        supportHours
        supportHoursUsed
        reservedComputeAllocation
        baseModel
        domain
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        embeddingConfig {
          maxChunkWords
          maxOverlapSentences
          chunkingStrategy
          imageExtractionStrategy
          minImageWidth
          minImageHeight
          aspectRatioMin
          aspectRatioMax
        }
        customGenerationConfig {
          styles
          domains
          scopes
          hasTopicsContext
          topics
          docTopK
          topK
          blender
          mode
          aiKnowledge
          compressor
        }
        customImageRecognitionModel
        customVectorDB
        workspaceAgents {
          nextToken
          startedAt
        }
        workspaceCustomPrompts {
          nextToken
          startedAt
        }
        aiConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        aggregatedConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        customUoiPrice
        disabled
        subscriptionPricingPlan {
          nextToken
          startedAt
        }
        folders {
          nextToken
          startedAt
        }
        trainingLogs {
          nextToken
          startedAt
        }
        entities {
          nextToken
          startedAt
        }
        appLogs {
          nextToken
          startedAt
        }
        batchJobs {
          nextToken
          startedAt
        }
        dictionaryItems {
          nextToken
          startedAt
        }
        requestsLogs {
          nextToken
          startedAt
        }
        communicationServices {
          nextToken
          startedAt
        }
        sites {
          nextToken
          startedAt
        }
        cronJobs {
          nextToken
          startedAt
        }
        customExecutionEnvironments {
          nextToken
          startedAt
        }
        users
        userCognitoIds
        usersAccessLevel {
          nextToken
          startedAt
        }
        workspaceCreationDate
        workspaceModelReady
        enableDeleteFunctionInAgents
        enableUpdateFunctionInAgents
        enableCustomFunctionInAgents
        defaultChatAgent
        defaultBusinessAnalystAgent
        defaultContentCreatorAgent
        isSentimentReviewerEnabled
        isExtendedContentCreatorEnabled
        isExtendedBusinessAnalystReportEnabled
        customIndexedDBendpoint
        createdBy
        updatedBy
        federationMetadataUrl
        federationMetadataUrlStatus
        federationMetadataUrlType
        ssoType
        ssoDomain
        ssoProviderName
        isMultiLanguageEnabled
        customChartingConfig
        twilioConfig
        emailConfig
        isMFAEnabled
        advancedVectorisation
        advancedCompute
        enableAutoInvite
        autoInviteDomain
        autoInviteUserRole
        customMaxPowerUsers
        customUoiBudget
        requestsPer30MinutesFactor
        webhookUrl
        webhookAuthorisationType
        webhookAuthorisationID
        logo
        enforceRegionalModels
        blockedModels
        billingPeriodStart
        billingPeriodEnd
        parentWorkspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const userWorkspaces = /* GraphQL */ `
  query UserWorkspaces(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWorkspaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    UserWorkspaces(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        title
        visibility
        userID
        isMed
        type
        usagePlanID
        workspaceTokenID
        workspaceToken
        subscriptionType
        subscriptionId
        subscriptionStatus
        enableExperimentalFeatures
        utilityEndpoint
        utilityUrl
        utilityUrlStatus
        utilityUrlType
        utilityBaseModel
        utilityProvider
        codingEndpoint
        codingUrl
        codingUrlStatus
        codingUrlType
        codingBaseModel
        codingProvider
        generalPurposeEndpoint
        generalPurposeUrl
        generalPurposeUrlStatus
        generalPurposeUrlType
        generalPurposeBaseModel
        generalPurposeProvider
        qaEnpoint
        qaUrl
        qaUrlStatus
        qaUrlType
        qaBaseModel
        qaProvider
        cnEndpoint
        cnUrl
        cnUrlStatus
        cnUrlType
        cnBaseModel
        cnProvider
        gnEnpoint
        gnUrl
        gnUrlStatus
        gnUrlType
        gnBaseModel
        gnProvider
        nlpEnpoint
        nlpUrl
        nlpUrlStatus
        nlpUrlType
        nlpBaseModel
        nlpProvider
        embeddingEndpoint
        embeddingUrl
        embeddingUrlStatus
        embeddingUrlType
        embeddingBaseModel
        embeddingProvider
        chartingEndpoint
        chartingUrl
        chartingUrlStatus
        chartingUrlType
        chartingBaseModel
        chartingProvider
        imagingEndpoint
        imagingUrl
        imagingUrlStatus
        imagingUrlType
        imagingBaseModel
        imagingProvider
        reasoningEndpoint
        reasoningUrl
        reasoningUrlStatus
        reasoningUrlType
        reasoningBaseModel
        reasoningProvider
        defaultChatVisibility
        billingStatus
        lastBillingDate
        lastConsumptionNotificationDate
        activeUntil
        paymentFailed
        bulkImportAllowed
        lastPaymentAttempt
        targetSubscriptionType
        lastChangeSubscriptionDate
        maxUsers
        minUsers
        contractStartDate
        xeroId
        xeroContactId
        xeroInvoiceId
        lastXeroBillingDate
        billingProvider
        supportHours
        supportHoursUsed
        reservedComputeAllocation
        baseModel
        domain
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        embeddingConfig {
          maxChunkWords
          maxOverlapSentences
          chunkingStrategy
          imageExtractionStrategy
          minImageWidth
          minImageHeight
          aspectRatioMin
          aspectRatioMax
        }
        customGenerationConfig {
          styles
          domains
          scopes
          hasTopicsContext
          topics
          docTopK
          topK
          blender
          mode
          aiKnowledge
          compressor
        }
        customImageRecognitionModel
        customVectorDB
        workspaceAgents {
          nextToken
          startedAt
        }
        workspaceCustomPrompts {
          nextToken
          startedAt
        }
        aiConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        aggregatedConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        customUoiPrice
        disabled
        subscriptionPricingPlan {
          nextToken
          startedAt
        }
        folders {
          nextToken
          startedAt
        }
        trainingLogs {
          nextToken
          startedAt
        }
        entities {
          nextToken
          startedAt
        }
        appLogs {
          nextToken
          startedAt
        }
        batchJobs {
          nextToken
          startedAt
        }
        dictionaryItems {
          nextToken
          startedAt
        }
        requestsLogs {
          nextToken
          startedAt
        }
        communicationServices {
          nextToken
          startedAt
        }
        sites {
          nextToken
          startedAt
        }
        cronJobs {
          nextToken
          startedAt
        }
        customExecutionEnvironments {
          nextToken
          startedAt
        }
        users
        userCognitoIds
        usersAccessLevel {
          nextToken
          startedAt
        }
        workspaceCreationDate
        workspaceModelReady
        enableDeleteFunctionInAgents
        enableUpdateFunctionInAgents
        enableCustomFunctionInAgents
        defaultChatAgent
        defaultBusinessAnalystAgent
        defaultContentCreatorAgent
        isSentimentReviewerEnabled
        isExtendedContentCreatorEnabled
        isExtendedBusinessAnalystReportEnabled
        customIndexedDBendpoint
        createdBy
        updatedBy
        federationMetadataUrl
        federationMetadataUrlStatus
        federationMetadataUrlType
        ssoType
        ssoDomain
        ssoProviderName
        isMultiLanguageEnabled
        customChartingConfig
        twilioConfig
        emailConfig
        isMFAEnabled
        advancedVectorisation
        advancedCompute
        enableAutoInvite
        autoInviteDomain
        autoInviteUserRole
        customMaxPowerUsers
        customUoiBudget
        requestsPer30MinutesFactor
        webhookUrl
        webhookAuthorisationType
        webhookAuthorisationID
        logo
        enforceRegionalModels
        blockedModels
        billingPeriodStart
        billingPeriodEnd
        parentWorkspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const workspacesByToken = /* GraphQL */ `
  query WorkspacesByToken(
    $workspaceToken: String!
    $sortDirection: ModelSortDirection
    $filter: ModelWorkspaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workspacesByToken(
      workspaceToken: $workspaceToken
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        title
        visibility
        userID
        isMed
        type
        usagePlanID
        workspaceTokenID
        workspaceToken
        subscriptionType
        subscriptionId
        subscriptionStatus
        enableExperimentalFeatures
        utilityEndpoint
        utilityUrl
        utilityUrlStatus
        utilityUrlType
        utilityBaseModel
        utilityProvider
        codingEndpoint
        codingUrl
        codingUrlStatus
        codingUrlType
        codingBaseModel
        codingProvider
        generalPurposeEndpoint
        generalPurposeUrl
        generalPurposeUrlStatus
        generalPurposeUrlType
        generalPurposeBaseModel
        generalPurposeProvider
        qaEnpoint
        qaUrl
        qaUrlStatus
        qaUrlType
        qaBaseModel
        qaProvider
        cnEndpoint
        cnUrl
        cnUrlStatus
        cnUrlType
        cnBaseModel
        cnProvider
        gnEnpoint
        gnUrl
        gnUrlStatus
        gnUrlType
        gnBaseModel
        gnProvider
        nlpEnpoint
        nlpUrl
        nlpUrlStatus
        nlpUrlType
        nlpBaseModel
        nlpProvider
        embeddingEndpoint
        embeddingUrl
        embeddingUrlStatus
        embeddingUrlType
        embeddingBaseModel
        embeddingProvider
        chartingEndpoint
        chartingUrl
        chartingUrlStatus
        chartingUrlType
        chartingBaseModel
        chartingProvider
        imagingEndpoint
        imagingUrl
        imagingUrlStatus
        imagingUrlType
        imagingBaseModel
        imagingProvider
        reasoningEndpoint
        reasoningUrl
        reasoningUrlStatus
        reasoningUrlType
        reasoningBaseModel
        reasoningProvider
        defaultChatVisibility
        billingStatus
        lastBillingDate
        lastConsumptionNotificationDate
        activeUntil
        paymentFailed
        bulkImportAllowed
        lastPaymentAttempt
        targetSubscriptionType
        lastChangeSubscriptionDate
        maxUsers
        minUsers
        contractStartDate
        xeroId
        xeroContactId
        xeroInvoiceId
        lastXeroBillingDate
        billingProvider
        supportHours
        supportHoursUsed
        reservedComputeAllocation
        baseModel
        domain
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        embeddingConfig {
          maxChunkWords
          maxOverlapSentences
          chunkingStrategy
          imageExtractionStrategy
          minImageWidth
          minImageHeight
          aspectRatioMin
          aspectRatioMax
        }
        customGenerationConfig {
          styles
          domains
          scopes
          hasTopicsContext
          topics
          docTopK
          topK
          blender
          mode
          aiKnowledge
          compressor
        }
        customImageRecognitionModel
        customVectorDB
        workspaceAgents {
          nextToken
          startedAt
        }
        workspaceCustomPrompts {
          nextToken
          startedAt
        }
        aiConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        aggregatedConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        customUoiPrice
        disabled
        subscriptionPricingPlan {
          nextToken
          startedAt
        }
        folders {
          nextToken
          startedAt
        }
        trainingLogs {
          nextToken
          startedAt
        }
        entities {
          nextToken
          startedAt
        }
        appLogs {
          nextToken
          startedAt
        }
        batchJobs {
          nextToken
          startedAt
        }
        dictionaryItems {
          nextToken
          startedAt
        }
        requestsLogs {
          nextToken
          startedAt
        }
        communicationServices {
          nextToken
          startedAt
        }
        sites {
          nextToken
          startedAt
        }
        cronJobs {
          nextToken
          startedAt
        }
        customExecutionEnvironments {
          nextToken
          startedAt
        }
        users
        userCognitoIds
        usersAccessLevel {
          nextToken
          startedAt
        }
        workspaceCreationDate
        workspaceModelReady
        enableDeleteFunctionInAgents
        enableUpdateFunctionInAgents
        enableCustomFunctionInAgents
        defaultChatAgent
        defaultBusinessAnalystAgent
        defaultContentCreatorAgent
        isSentimentReviewerEnabled
        isExtendedContentCreatorEnabled
        isExtendedBusinessAnalystReportEnabled
        customIndexedDBendpoint
        createdBy
        updatedBy
        federationMetadataUrl
        federationMetadataUrlStatus
        federationMetadataUrlType
        ssoType
        ssoDomain
        ssoProviderName
        isMultiLanguageEnabled
        customChartingConfig
        twilioConfig
        emailConfig
        isMFAEnabled
        advancedVectorisation
        advancedCompute
        enableAutoInvite
        autoInviteDomain
        autoInviteUserRole
        customMaxPowerUsers
        customUoiBudget
        requestsPer30MinutesFactor
        webhookUrl
        webhookAuthorisationType
        webhookAuthorisationID
        logo
        enforceRegionalModels
        blockedModels
        billingPeriodStart
        billingPeriodEnd
        parentWorkspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const workspacesBySSOdomain = /* GraphQL */ `
  query WorkspacesBySSOdomain(
    $ssoDomain: String!
    $sortDirection: ModelSortDirection
    $filter: ModelWorkspaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workspacesBySSOdomain(
      ssoDomain: $ssoDomain
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        title
        visibility
        userID
        isMed
        type
        usagePlanID
        workspaceTokenID
        workspaceToken
        subscriptionType
        subscriptionId
        subscriptionStatus
        enableExperimentalFeatures
        utilityEndpoint
        utilityUrl
        utilityUrlStatus
        utilityUrlType
        utilityBaseModel
        utilityProvider
        codingEndpoint
        codingUrl
        codingUrlStatus
        codingUrlType
        codingBaseModel
        codingProvider
        generalPurposeEndpoint
        generalPurposeUrl
        generalPurposeUrlStatus
        generalPurposeUrlType
        generalPurposeBaseModel
        generalPurposeProvider
        qaEnpoint
        qaUrl
        qaUrlStatus
        qaUrlType
        qaBaseModel
        qaProvider
        cnEndpoint
        cnUrl
        cnUrlStatus
        cnUrlType
        cnBaseModel
        cnProvider
        gnEnpoint
        gnUrl
        gnUrlStatus
        gnUrlType
        gnBaseModel
        gnProvider
        nlpEnpoint
        nlpUrl
        nlpUrlStatus
        nlpUrlType
        nlpBaseModel
        nlpProvider
        embeddingEndpoint
        embeddingUrl
        embeddingUrlStatus
        embeddingUrlType
        embeddingBaseModel
        embeddingProvider
        chartingEndpoint
        chartingUrl
        chartingUrlStatus
        chartingUrlType
        chartingBaseModel
        chartingProvider
        imagingEndpoint
        imagingUrl
        imagingUrlStatus
        imagingUrlType
        imagingBaseModel
        imagingProvider
        reasoningEndpoint
        reasoningUrl
        reasoningUrlStatus
        reasoningUrlType
        reasoningBaseModel
        reasoningProvider
        defaultChatVisibility
        billingStatus
        lastBillingDate
        lastConsumptionNotificationDate
        activeUntil
        paymentFailed
        bulkImportAllowed
        lastPaymentAttempt
        targetSubscriptionType
        lastChangeSubscriptionDate
        maxUsers
        minUsers
        contractStartDate
        xeroId
        xeroContactId
        xeroInvoiceId
        lastXeroBillingDate
        billingProvider
        supportHours
        supportHoursUsed
        reservedComputeAllocation
        baseModel
        domain
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        embeddingConfig {
          maxChunkWords
          maxOverlapSentences
          chunkingStrategy
          imageExtractionStrategy
          minImageWidth
          minImageHeight
          aspectRatioMin
          aspectRatioMax
        }
        customGenerationConfig {
          styles
          domains
          scopes
          hasTopicsContext
          topics
          docTopK
          topK
          blender
          mode
          aiKnowledge
          compressor
        }
        customImageRecognitionModel
        customVectorDB
        workspaceAgents {
          nextToken
          startedAt
        }
        workspaceCustomPrompts {
          nextToken
          startedAt
        }
        aiConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        aggregatedConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        customUoiPrice
        disabled
        subscriptionPricingPlan {
          nextToken
          startedAt
        }
        folders {
          nextToken
          startedAt
        }
        trainingLogs {
          nextToken
          startedAt
        }
        entities {
          nextToken
          startedAt
        }
        appLogs {
          nextToken
          startedAt
        }
        batchJobs {
          nextToken
          startedAt
        }
        dictionaryItems {
          nextToken
          startedAt
        }
        requestsLogs {
          nextToken
          startedAt
        }
        communicationServices {
          nextToken
          startedAt
        }
        sites {
          nextToken
          startedAt
        }
        cronJobs {
          nextToken
          startedAt
        }
        customExecutionEnvironments {
          nextToken
          startedAt
        }
        users
        userCognitoIds
        usersAccessLevel {
          nextToken
          startedAt
        }
        workspaceCreationDate
        workspaceModelReady
        enableDeleteFunctionInAgents
        enableUpdateFunctionInAgents
        enableCustomFunctionInAgents
        defaultChatAgent
        defaultBusinessAnalystAgent
        defaultContentCreatorAgent
        isSentimentReviewerEnabled
        isExtendedContentCreatorEnabled
        isExtendedBusinessAnalystReportEnabled
        customIndexedDBendpoint
        createdBy
        updatedBy
        federationMetadataUrl
        federationMetadataUrlStatus
        federationMetadataUrlType
        ssoType
        ssoDomain
        ssoProviderName
        isMultiLanguageEnabled
        customChartingConfig
        twilioConfig
        emailConfig
        isMFAEnabled
        advancedVectorisation
        advancedCompute
        enableAutoInvite
        autoInviteDomain
        autoInviteUserRole
        customMaxPowerUsers
        customUoiBudget
        requestsPer30MinutesFactor
        webhookUrl
        webhookAuthorisationType
        webhookAuthorisationID
        logo
        enforceRegionalModels
        blockedModels
        billingPeriodStart
        billingPeriodEnd
        parentWorkspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const workspacesByInviteDomain = /* GraphQL */ `
  query WorkspacesByInviteDomain(
    $autoInviteDomain: String!
    $sortDirection: ModelSortDirection
    $filter: ModelWorkspaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workspacesByInviteDomain(
      autoInviteDomain: $autoInviteDomain
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        title
        visibility
        userID
        isMed
        type
        usagePlanID
        workspaceTokenID
        workspaceToken
        subscriptionType
        subscriptionId
        subscriptionStatus
        enableExperimentalFeatures
        utilityEndpoint
        utilityUrl
        utilityUrlStatus
        utilityUrlType
        utilityBaseModel
        utilityProvider
        codingEndpoint
        codingUrl
        codingUrlStatus
        codingUrlType
        codingBaseModel
        codingProvider
        generalPurposeEndpoint
        generalPurposeUrl
        generalPurposeUrlStatus
        generalPurposeUrlType
        generalPurposeBaseModel
        generalPurposeProvider
        qaEnpoint
        qaUrl
        qaUrlStatus
        qaUrlType
        qaBaseModel
        qaProvider
        cnEndpoint
        cnUrl
        cnUrlStatus
        cnUrlType
        cnBaseModel
        cnProvider
        gnEnpoint
        gnUrl
        gnUrlStatus
        gnUrlType
        gnBaseModel
        gnProvider
        nlpEnpoint
        nlpUrl
        nlpUrlStatus
        nlpUrlType
        nlpBaseModel
        nlpProvider
        embeddingEndpoint
        embeddingUrl
        embeddingUrlStatus
        embeddingUrlType
        embeddingBaseModel
        embeddingProvider
        chartingEndpoint
        chartingUrl
        chartingUrlStatus
        chartingUrlType
        chartingBaseModel
        chartingProvider
        imagingEndpoint
        imagingUrl
        imagingUrlStatus
        imagingUrlType
        imagingBaseModel
        imagingProvider
        reasoningEndpoint
        reasoningUrl
        reasoningUrlStatus
        reasoningUrlType
        reasoningBaseModel
        reasoningProvider
        defaultChatVisibility
        billingStatus
        lastBillingDate
        lastConsumptionNotificationDate
        activeUntil
        paymentFailed
        bulkImportAllowed
        lastPaymentAttempt
        targetSubscriptionType
        lastChangeSubscriptionDate
        maxUsers
        minUsers
        contractStartDate
        xeroId
        xeroContactId
        xeroInvoiceId
        lastXeroBillingDate
        billingProvider
        supportHours
        supportHoursUsed
        reservedComputeAllocation
        baseModel
        domain
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        embeddingConfig {
          maxChunkWords
          maxOverlapSentences
          chunkingStrategy
          imageExtractionStrategy
          minImageWidth
          minImageHeight
          aspectRatioMin
          aspectRatioMax
        }
        customGenerationConfig {
          styles
          domains
          scopes
          hasTopicsContext
          topics
          docTopK
          topK
          blender
          mode
          aiKnowledge
          compressor
        }
        customImageRecognitionModel
        customVectorDB
        workspaceAgents {
          nextToken
          startedAt
        }
        workspaceCustomPrompts {
          nextToken
          startedAt
        }
        aiConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        aggregatedConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        customUoiPrice
        disabled
        subscriptionPricingPlan {
          nextToken
          startedAt
        }
        folders {
          nextToken
          startedAt
        }
        trainingLogs {
          nextToken
          startedAt
        }
        entities {
          nextToken
          startedAt
        }
        appLogs {
          nextToken
          startedAt
        }
        batchJobs {
          nextToken
          startedAt
        }
        dictionaryItems {
          nextToken
          startedAt
        }
        requestsLogs {
          nextToken
          startedAt
        }
        communicationServices {
          nextToken
          startedAt
        }
        sites {
          nextToken
          startedAt
        }
        cronJobs {
          nextToken
          startedAt
        }
        customExecutionEnvironments {
          nextToken
          startedAt
        }
        users
        userCognitoIds
        usersAccessLevel {
          nextToken
          startedAt
        }
        workspaceCreationDate
        workspaceModelReady
        enableDeleteFunctionInAgents
        enableUpdateFunctionInAgents
        enableCustomFunctionInAgents
        defaultChatAgent
        defaultBusinessAnalystAgent
        defaultContentCreatorAgent
        isSentimentReviewerEnabled
        isExtendedContentCreatorEnabled
        isExtendedBusinessAnalystReportEnabled
        customIndexedDBendpoint
        createdBy
        updatedBy
        federationMetadataUrl
        federationMetadataUrlStatus
        federationMetadataUrlType
        ssoType
        ssoDomain
        ssoProviderName
        isMultiLanguageEnabled
        customChartingConfig
        twilioConfig
        emailConfig
        isMFAEnabled
        advancedVectorisation
        advancedCompute
        enableAutoInvite
        autoInviteDomain
        autoInviteUserRole
        customMaxPowerUsers
        customUoiBudget
        requestsPer30MinutesFactor
        webhookUrl
        webhookAuthorisationType
        webhookAuthorisationID
        logo
        enforceRegionalModels
        blockedModels
        billingPeriodStart
        billingPeriodEnd
        parentWorkspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const workspacesByParent = /* GraphQL */ `
  query WorkspacesByParent(
    $parentWorkspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWorkspaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workspacesByParent(
      parentWorkspaceID: $parentWorkspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        title
        visibility
        userID
        isMed
        type
        usagePlanID
        workspaceTokenID
        workspaceToken
        subscriptionType
        subscriptionId
        subscriptionStatus
        enableExperimentalFeatures
        utilityEndpoint
        utilityUrl
        utilityUrlStatus
        utilityUrlType
        utilityBaseModel
        utilityProvider
        codingEndpoint
        codingUrl
        codingUrlStatus
        codingUrlType
        codingBaseModel
        codingProvider
        generalPurposeEndpoint
        generalPurposeUrl
        generalPurposeUrlStatus
        generalPurposeUrlType
        generalPurposeBaseModel
        generalPurposeProvider
        qaEnpoint
        qaUrl
        qaUrlStatus
        qaUrlType
        qaBaseModel
        qaProvider
        cnEndpoint
        cnUrl
        cnUrlStatus
        cnUrlType
        cnBaseModel
        cnProvider
        gnEnpoint
        gnUrl
        gnUrlStatus
        gnUrlType
        gnBaseModel
        gnProvider
        nlpEnpoint
        nlpUrl
        nlpUrlStatus
        nlpUrlType
        nlpBaseModel
        nlpProvider
        embeddingEndpoint
        embeddingUrl
        embeddingUrlStatus
        embeddingUrlType
        embeddingBaseModel
        embeddingProvider
        chartingEndpoint
        chartingUrl
        chartingUrlStatus
        chartingUrlType
        chartingBaseModel
        chartingProvider
        imagingEndpoint
        imagingUrl
        imagingUrlStatus
        imagingUrlType
        imagingBaseModel
        imagingProvider
        reasoningEndpoint
        reasoningUrl
        reasoningUrlStatus
        reasoningUrlType
        reasoningBaseModel
        reasoningProvider
        defaultChatVisibility
        billingStatus
        lastBillingDate
        lastConsumptionNotificationDate
        activeUntil
        paymentFailed
        bulkImportAllowed
        lastPaymentAttempt
        targetSubscriptionType
        lastChangeSubscriptionDate
        maxUsers
        minUsers
        contractStartDate
        xeroId
        xeroContactId
        xeroInvoiceId
        lastXeroBillingDate
        billingProvider
        supportHours
        supportHoursUsed
        reservedComputeAllocation
        baseModel
        domain
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        embeddingConfig {
          maxChunkWords
          maxOverlapSentences
          chunkingStrategy
          imageExtractionStrategy
          minImageWidth
          minImageHeight
          aspectRatioMin
          aspectRatioMax
        }
        customGenerationConfig {
          styles
          domains
          scopes
          hasTopicsContext
          topics
          docTopK
          topK
          blender
          mode
          aiKnowledge
          compressor
        }
        customImageRecognitionModel
        customVectorDB
        workspaceAgents {
          nextToken
          startedAt
        }
        workspaceCustomPrompts {
          nextToken
          startedAt
        }
        aiConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        aggregatedConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        customUoiPrice
        disabled
        subscriptionPricingPlan {
          nextToken
          startedAt
        }
        folders {
          nextToken
          startedAt
        }
        trainingLogs {
          nextToken
          startedAt
        }
        entities {
          nextToken
          startedAt
        }
        appLogs {
          nextToken
          startedAt
        }
        batchJobs {
          nextToken
          startedAt
        }
        dictionaryItems {
          nextToken
          startedAt
        }
        requestsLogs {
          nextToken
          startedAt
        }
        communicationServices {
          nextToken
          startedAt
        }
        sites {
          nextToken
          startedAt
        }
        cronJobs {
          nextToken
          startedAt
        }
        customExecutionEnvironments {
          nextToken
          startedAt
        }
        users
        userCognitoIds
        usersAccessLevel {
          nextToken
          startedAt
        }
        workspaceCreationDate
        workspaceModelReady
        enableDeleteFunctionInAgents
        enableUpdateFunctionInAgents
        enableCustomFunctionInAgents
        defaultChatAgent
        defaultBusinessAnalystAgent
        defaultContentCreatorAgent
        isSentimentReviewerEnabled
        isExtendedContentCreatorEnabled
        isExtendedBusinessAnalystReportEnabled
        customIndexedDBendpoint
        createdBy
        updatedBy
        federationMetadataUrl
        federationMetadataUrlStatus
        federationMetadataUrlType
        ssoType
        ssoDomain
        ssoProviderName
        isMultiLanguageEnabled
        customChartingConfig
        twilioConfig
        emailConfig
        isMFAEnabled
        advancedVectorisation
        advancedCompute
        enableAutoInvite
        autoInviteDomain
        autoInviteUserRole
        customMaxPowerUsers
        customUoiBudget
        requestsPer30MinutesFactor
        webhookUrl
        webhookAuthorisationType
        webhookAuthorisationID
        logo
        enforceRegionalModels
        blockedModels
        billingPeriodStart
        billingPeriodEnd
        parentWorkspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getUserPolicy = /* GraphQL */ `
  query GetUserPolicy($id: ID!) {
    getUserPolicy(id: $id) {
      id
      workspaceID
      inheritFrom
      properties
      allowedDocs
      allowedModels
      allowedAgents
      createdBy
      createdAt
      creationTime
      updatedAt
      updatedBy
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listUserPolicies = /* GraphQL */ `
  query ListUserPolicies(
    $filter: ModelUserPolicyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserPolicies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        workspaceID
        inheritFrom
        properties
        allowedDocs
        allowedModels
        allowedAgents
        createdBy
        createdAt
        creationTime
        updatedAt
        updatedBy
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncUserPolicies = /* GraphQL */ `
  query SyncUserPolicies(
    $filter: ModelUserPolicyFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserPolicies(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        workspaceID
        inheritFrom
        properties
        allowedDocs
        allowedModels
        allowedAgents
        createdBy
        createdAt
        creationTime
        updatedAt
        updatedBy
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const policiesToWorkspaceMapping = /* GraphQL */ `
  query PoliciesToWorkspaceMapping(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserPolicyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    policiesToWorkspaceMapping(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        workspaceID
        inheritFrom
        properties
        allowedDocs
        allowedModels
        allowedAgents
        createdBy
        createdAt
        creationTime
        updatedAt
        updatedBy
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getUserWorkspaceType = /* GraphQL */ `
  query GetUserWorkspaceType($id: ID!) {
    getUserWorkspaceType(id: $id) {
      id
      workspaceID
      userID
      userType
      policyID
      favoriteAgents
      recentLocalFolders
      recentFiles
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listUserWorkspaceTypes = /* GraphQL */ `
  query ListUserWorkspaceTypes(
    $filter: ModelUserWorkspaceTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserWorkspaceTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        workspaceID
        userID
        userType
        policyID
        favoriteAgents
        recentLocalFolders
        recentFiles
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncUserWorkspaceTypes = /* GraphQL */ `
  query SyncUserWorkspaceTypes(
    $filter: ModelUserWorkspaceTypeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserWorkspaceTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        workspaceID
        userID
        userType
        policyID
        favoriteAgents
        recentLocalFolders
        recentFiles
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const userToWorkspaceMapping = /* GraphQL */ `
  query UserToWorkspaceMapping(
    $workspaceID: ID!
    $userID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserWorkspaceTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userToWorkspaceMapping(
      workspaceID: $workspaceID
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        workspaceID
        userID
        userType
        policyID
        favoriteAgents
        recentLocalFolders
        recentFiles
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const workspacesByUser = /* GraphQL */ `
  query WorkspacesByUser(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserWorkspaceTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workspacesByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        workspaceID
        userID
        userType
        policyID
        favoriteAgents
        recentLocalFolders
        recentFiles
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getAgent = /* GraphQL */ `
  query GetAgent($id: ID!) {
    getAgent(id: $id) {
      id
      type
      label
      description
      interpolationString
      emoji
      color
      darkColor
      icon
      largeLogo
      icoUrl
      logoBackground
      darkLogoBackground
      messageOnLaunch
      messagesOnLaunch
      rotateMessagesOnLaunch
      rotateMessagesOnLaunchInterval
      placeholderMessageOnLoading
      dynamicPlaceholderMessageOnLoading
      customGreetingInstructions
      customConclusionInstructions
      customChartingInstructions
      customSummarisationInstructions
      customImagesInstructions
      customToolingInstructions
      placeholderInputMessage
      openByDefault
      agenticCodingModel
      disclaimer
      showDocumentsReferences
      isDefault
      hasMemory
      hasImages
      promptTopKeywords
      keyWordsForKnowledgeBase
      hasTopicsContext
      hasFunctions
      advancedLanguageDetection
      allowedTopics
      staticDocs
      defaultAnswer
      noKnowledgeDefaultAnswer
      quickQuestions
      recencyImportance
      maxRecencyIncrease
      recencyTopKIncreaseFactor
      stopSequence
      examples {
        question
        answer
      }
      enhancementPassage
      inhibitionPassage
      pertinencePassage
      goals
      qaUrl
      topK
      mode
      showCodeInExecution
      hideReasoning
      charting
      summarisation
      compressor
      docTopK
      minRetrievalScore
      timeSignificance
      hasModeration
      customModerations
      moderationMessage
      languageDetectionConfidence
      maxHistory
      maxTokens
      topicEnhancer
      maxTopics
      blender
      temperature
      seed
      version
      subject
      workspaceID
      createdBy
      updatedBy
      agentFunctions
      isGlobal
      promptBuffering
      functionContext
      plainTextOutput
      chainOfThoughts
      treeOfThoughts
      extendedOutput
      agentType
      agentsPool
      mcps
      maxPlanningSteps
      maxBrowserSteps
      virtualDesktopInstructions
      planningInstructions
      plannerExecutionAttempts
      plannerRequiresApprovalForPlanExecution
      plannerEmailOnApprovalRequest
      plannerEmailOnFailedPlan
      plannerEmailOnCompletedPlan
      plannerAutoAgentSpawn
      plannerRetainsSpawnedAgents
      plannerPromptsAgentsProgrammatically
      plannerDeepThinking
      allowReplanning
      plannerProceedsWhenImprovementsRequired
      plannerApproverEmails
      reviewInstructions
      showReferencesToInternalDocs
      showCitations
      forceJsonOutput
      agenticRAG
      preventWidgetUsage
      allowFeedback
      generateExtendedReport
      showTimeForResponse
      showDetectedLanguage
      showRoutedModel
      isMultiLanguageEnabled
      hasMath
      hasCode
      hasComputer
      hasNER
      restrictedAccess
      restrictedAccessUsers
      splashTitle
      showSplashWhenEmpty
      llmEndpoint
      llmUrl
      llmUrlStatus
      llmUrlType
      llmBaseModel
      llmProvider
      llmTopK
      llmSeed
      forcedTheme
      adverserialProvider
      adverserialModel
      functionCallingProvider
      functionCallingModel
      visionProvider
      visionModel
      browserProvider
      browserModel
      videoGenerationProvider
      videoGenerationModel
      showAgentName
      allowImagesUpload
      allowVideosUpload
      allowAudiosUpload
      allowDocsUpload
      allowImagesGeneration
      baseImageGenerationModel
      maxImagesGenerated
      advancedImageGeneration
      allowVideosGeneration
      allowAudiosGeneration
      allowIntrospection
      voiceFileKey
      audiosGenerationTtsModel
      audiosGenerationVoiceName
      audiosGenerationSpeechMode
      allowInternetSearch
      bannedDomains
      maxUrlsForInternetSearch
      allowDeepInternetSearch
      internetSearchModes
      internetSearchLocation
      autoVoiceMode
      voiceSensitivity
      keywordsWeightInRetrieval
      customCodeExecutionEnvironments
      phoneNumberAsSender
      whatsappNumberAsSender
      emailAsSender
      communicationServices
      channelCallbackDelay
      ephemeralAgent
      parentAgentID
      parentChatID
      minimumSubscriptionType
      clonedAgentID
      clonedAgentIDIcon
      hasContentCreation
      hasEntityExtraction
      department
      metadata
      allowEmailToAgent
      allowedEmails
      agentHiringTemplate
      agentDesktopVM
      agentDesktopPortRange
      agentDesktopCredentials
      agentDesktopBrowser
      allow3dModelGeneration
      agentLongTermMemory
      isLongTermMemoryEnabled
      allowExternalAPI
      forceNewThreadOnProgrammaticRequest
      dynamicModelSelectionInstructions
      contextRelevancyRatio
      reasoningBudget
      reasoningMode
      reasoningEffort
      fnReasoningEffort
      agentFnParams
      canvasEnabled
      advancedCompute
      reRank
      minDeepSearchPagesPercentage
      voiceName
      vadThresholds
      analyticsInstructions
      analyticsCustomFields
      alertIDs
      ragInstructions
      allowAskQuestion
      ragSearchStrategy
      minChunksBeforeCompleteness
      ragCompletenessThreshold
      voiceInstructions
      sttModel
      llmVoiceModel
      ttsModel
      defaultVoiceLanguage
      voiceMinSilenceDuration
      voiceMinEndpointingDelay
      voiceMinInterruptionDuration
      enableVoiceIntermissions
      voiceBackgroundNoise
      sipPhoneNumber
      sipDispatchRuleId
      enableInboundSip
      enableOutboundSip
      enableJsonOutput
      jsonOutputStructure
      predictedPlanJson
      useInterleavedReasoning
      interleavedPreset
      maxTotalToolCalls
      maxConsecutiveSameTool
      maxConsecutiveFailures
      regionalEndpoint
      agentVersion
      agentCategoryType
      maxSessionUoI
      maxSessionTurns
      maxSessionMessage
      showWidgetControls
      allowIpRotationViaProxy
      showToolCallsDetailsInWidget
      allowProxyScraping
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listAgents = /* GraphQL */ `
  query ListAgents(
    $filter: ModelAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        label
        description
        interpolationString
        emoji
        color
        darkColor
        icon
        largeLogo
        icoUrl
        logoBackground
        darkLogoBackground
        messageOnLaunch
        messagesOnLaunch
        rotateMessagesOnLaunch
        rotateMessagesOnLaunchInterval
        placeholderMessageOnLoading
        dynamicPlaceholderMessageOnLoading
        customGreetingInstructions
        customConclusionInstructions
        customChartingInstructions
        customSummarisationInstructions
        customImagesInstructions
        customToolingInstructions
        placeholderInputMessage
        openByDefault
        agenticCodingModel
        disclaimer
        showDocumentsReferences
        isDefault
        hasMemory
        hasImages
        promptTopKeywords
        keyWordsForKnowledgeBase
        hasTopicsContext
        hasFunctions
        advancedLanguageDetection
        allowedTopics
        staticDocs
        defaultAnswer
        noKnowledgeDefaultAnswer
        quickQuestions
        recencyImportance
        maxRecencyIncrease
        recencyTopKIncreaseFactor
        stopSequence
        examples {
          question
          answer
        }
        enhancementPassage
        inhibitionPassage
        pertinencePassage
        goals
        qaUrl
        topK
        mode
        showCodeInExecution
        hideReasoning
        charting
        summarisation
        compressor
        docTopK
        minRetrievalScore
        timeSignificance
        hasModeration
        customModerations
        moderationMessage
        languageDetectionConfidence
        maxHistory
        maxTokens
        topicEnhancer
        maxTopics
        blender
        temperature
        seed
        version
        subject
        workspaceID
        createdBy
        updatedBy
        agentFunctions
        isGlobal
        promptBuffering
        functionContext
        plainTextOutput
        chainOfThoughts
        treeOfThoughts
        extendedOutput
        agentType
        agentsPool
        mcps
        maxPlanningSteps
        maxBrowserSteps
        virtualDesktopInstructions
        planningInstructions
        plannerExecutionAttempts
        plannerRequiresApprovalForPlanExecution
        plannerEmailOnApprovalRequest
        plannerEmailOnFailedPlan
        plannerEmailOnCompletedPlan
        plannerAutoAgentSpawn
        plannerRetainsSpawnedAgents
        plannerPromptsAgentsProgrammatically
        plannerDeepThinking
        allowReplanning
        plannerProceedsWhenImprovementsRequired
        plannerApproverEmails
        reviewInstructions
        showReferencesToInternalDocs
        showCitations
        forceJsonOutput
        agenticRAG
        preventWidgetUsage
        allowFeedback
        generateExtendedReport
        showTimeForResponse
        showDetectedLanguage
        showRoutedModel
        isMultiLanguageEnabled
        hasMath
        hasCode
        hasComputer
        hasNER
        restrictedAccess
        restrictedAccessUsers
        splashTitle
        showSplashWhenEmpty
        llmEndpoint
        llmUrl
        llmUrlStatus
        llmUrlType
        llmBaseModel
        llmProvider
        llmTopK
        llmSeed
        forcedTheme
        adverserialProvider
        adverserialModel
        functionCallingProvider
        functionCallingModel
        visionProvider
        visionModel
        browserProvider
        browserModel
        videoGenerationProvider
        videoGenerationModel
        showAgentName
        allowImagesUpload
        allowVideosUpload
        allowAudiosUpload
        allowDocsUpload
        allowImagesGeneration
        baseImageGenerationModel
        maxImagesGenerated
        advancedImageGeneration
        allowVideosGeneration
        allowAudiosGeneration
        allowIntrospection
        voiceFileKey
        audiosGenerationTtsModel
        audiosGenerationVoiceName
        audiosGenerationSpeechMode
        allowInternetSearch
        bannedDomains
        maxUrlsForInternetSearch
        allowDeepInternetSearch
        internetSearchModes
        internetSearchLocation
        autoVoiceMode
        voiceSensitivity
        keywordsWeightInRetrieval
        customCodeExecutionEnvironments
        phoneNumberAsSender
        whatsappNumberAsSender
        emailAsSender
        communicationServices
        channelCallbackDelay
        ephemeralAgent
        parentAgentID
        parentChatID
        minimumSubscriptionType
        clonedAgentID
        clonedAgentIDIcon
        hasContentCreation
        hasEntityExtraction
        department
        metadata
        allowEmailToAgent
        allowedEmails
        agentHiringTemplate
        agentDesktopVM
        agentDesktopPortRange
        agentDesktopCredentials
        agentDesktopBrowser
        allow3dModelGeneration
        agentLongTermMemory
        isLongTermMemoryEnabled
        allowExternalAPI
        forceNewThreadOnProgrammaticRequest
        dynamicModelSelectionInstructions
        contextRelevancyRatio
        reasoningBudget
        reasoningMode
        reasoningEffort
        fnReasoningEffort
        agentFnParams
        canvasEnabled
        advancedCompute
        reRank
        minDeepSearchPagesPercentage
        voiceName
        vadThresholds
        analyticsInstructions
        analyticsCustomFields
        alertIDs
        ragInstructions
        allowAskQuestion
        ragSearchStrategy
        minChunksBeforeCompleteness
        ragCompletenessThreshold
        voiceInstructions
        sttModel
        llmVoiceModel
        ttsModel
        defaultVoiceLanguage
        voiceMinSilenceDuration
        voiceMinEndpointingDelay
        voiceMinInterruptionDuration
        enableVoiceIntermissions
        voiceBackgroundNoise
        sipPhoneNumber
        sipDispatchRuleId
        enableInboundSip
        enableOutboundSip
        enableJsonOutput
        jsonOutputStructure
        predictedPlanJson
        useInterleavedReasoning
        interleavedPreset
        maxTotalToolCalls
        maxConsecutiveSameTool
        maxConsecutiveFailures
        regionalEndpoint
        agentVersion
        agentCategoryType
        maxSessionUoI
        maxSessionTurns
        maxSessionMessage
        showWidgetControls
        allowIpRotationViaProxy
        showToolCallsDetailsInWidget
        allowProxyScraping
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncAgents = /* GraphQL */ `
  query SyncAgents(
    $filter: ModelAgentFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAgents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        type
        label
        description
        interpolationString
        emoji
        color
        darkColor
        icon
        largeLogo
        icoUrl
        logoBackground
        darkLogoBackground
        messageOnLaunch
        messagesOnLaunch
        rotateMessagesOnLaunch
        rotateMessagesOnLaunchInterval
        placeholderMessageOnLoading
        dynamicPlaceholderMessageOnLoading
        customGreetingInstructions
        customConclusionInstructions
        customChartingInstructions
        customSummarisationInstructions
        customImagesInstructions
        customToolingInstructions
        placeholderInputMessage
        openByDefault
        agenticCodingModel
        disclaimer
        showDocumentsReferences
        isDefault
        hasMemory
        hasImages
        promptTopKeywords
        keyWordsForKnowledgeBase
        hasTopicsContext
        hasFunctions
        advancedLanguageDetection
        allowedTopics
        staticDocs
        defaultAnswer
        noKnowledgeDefaultAnswer
        quickQuestions
        recencyImportance
        maxRecencyIncrease
        recencyTopKIncreaseFactor
        stopSequence
        examples {
          question
          answer
        }
        enhancementPassage
        inhibitionPassage
        pertinencePassage
        goals
        qaUrl
        topK
        mode
        showCodeInExecution
        hideReasoning
        charting
        summarisation
        compressor
        docTopK
        minRetrievalScore
        timeSignificance
        hasModeration
        customModerations
        moderationMessage
        languageDetectionConfidence
        maxHistory
        maxTokens
        topicEnhancer
        maxTopics
        blender
        temperature
        seed
        version
        subject
        workspaceID
        createdBy
        updatedBy
        agentFunctions
        isGlobal
        promptBuffering
        functionContext
        plainTextOutput
        chainOfThoughts
        treeOfThoughts
        extendedOutput
        agentType
        agentsPool
        mcps
        maxPlanningSteps
        maxBrowserSteps
        virtualDesktopInstructions
        planningInstructions
        plannerExecutionAttempts
        plannerRequiresApprovalForPlanExecution
        plannerEmailOnApprovalRequest
        plannerEmailOnFailedPlan
        plannerEmailOnCompletedPlan
        plannerAutoAgentSpawn
        plannerRetainsSpawnedAgents
        plannerPromptsAgentsProgrammatically
        plannerDeepThinking
        allowReplanning
        plannerProceedsWhenImprovementsRequired
        plannerApproverEmails
        reviewInstructions
        showReferencesToInternalDocs
        showCitations
        forceJsonOutput
        agenticRAG
        preventWidgetUsage
        allowFeedback
        generateExtendedReport
        showTimeForResponse
        showDetectedLanguage
        showRoutedModel
        isMultiLanguageEnabled
        hasMath
        hasCode
        hasComputer
        hasNER
        restrictedAccess
        restrictedAccessUsers
        splashTitle
        showSplashWhenEmpty
        llmEndpoint
        llmUrl
        llmUrlStatus
        llmUrlType
        llmBaseModel
        llmProvider
        llmTopK
        llmSeed
        forcedTheme
        adverserialProvider
        adverserialModel
        functionCallingProvider
        functionCallingModel
        visionProvider
        visionModel
        browserProvider
        browserModel
        videoGenerationProvider
        videoGenerationModel
        showAgentName
        allowImagesUpload
        allowVideosUpload
        allowAudiosUpload
        allowDocsUpload
        allowImagesGeneration
        baseImageGenerationModel
        maxImagesGenerated
        advancedImageGeneration
        allowVideosGeneration
        allowAudiosGeneration
        allowIntrospection
        voiceFileKey
        audiosGenerationTtsModel
        audiosGenerationVoiceName
        audiosGenerationSpeechMode
        allowInternetSearch
        bannedDomains
        maxUrlsForInternetSearch
        allowDeepInternetSearch
        internetSearchModes
        internetSearchLocation
        autoVoiceMode
        voiceSensitivity
        keywordsWeightInRetrieval
        customCodeExecutionEnvironments
        phoneNumberAsSender
        whatsappNumberAsSender
        emailAsSender
        communicationServices
        channelCallbackDelay
        ephemeralAgent
        parentAgentID
        parentChatID
        minimumSubscriptionType
        clonedAgentID
        clonedAgentIDIcon
        hasContentCreation
        hasEntityExtraction
        department
        metadata
        allowEmailToAgent
        allowedEmails
        agentHiringTemplate
        agentDesktopVM
        agentDesktopPortRange
        agentDesktopCredentials
        agentDesktopBrowser
        allow3dModelGeneration
        agentLongTermMemory
        isLongTermMemoryEnabled
        allowExternalAPI
        forceNewThreadOnProgrammaticRequest
        dynamicModelSelectionInstructions
        contextRelevancyRatio
        reasoningBudget
        reasoningMode
        reasoningEffort
        fnReasoningEffort
        agentFnParams
        canvasEnabled
        advancedCompute
        reRank
        minDeepSearchPagesPercentage
        voiceName
        vadThresholds
        analyticsInstructions
        analyticsCustomFields
        alertIDs
        ragInstructions
        allowAskQuestion
        ragSearchStrategy
        minChunksBeforeCompleteness
        ragCompletenessThreshold
        voiceInstructions
        sttModel
        llmVoiceModel
        ttsModel
        defaultVoiceLanguage
        voiceMinSilenceDuration
        voiceMinEndpointingDelay
        voiceMinInterruptionDuration
        enableVoiceIntermissions
        voiceBackgroundNoise
        sipPhoneNumber
        sipDispatchRuleId
        enableInboundSip
        enableOutboundSip
        enableJsonOutput
        jsonOutputStructure
        predictedPlanJson
        useInterleavedReasoning
        interleavedPreset
        maxTotalToolCalls
        maxConsecutiveSameTool
        maxConsecutiveFailures
        regionalEndpoint
        agentVersion
        agentCategoryType
        maxSessionUoI
        maxSessionTurns
        maxSessionMessage
        showWidgetControls
        allowIpRotationViaProxy
        showToolCallsDetailsInWidget
        allowProxyScraping
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const agentsByWorkspace = /* GraphQL */ `
  query AgentsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    agentsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        label
        description
        interpolationString
        emoji
        color
        darkColor
        icon
        largeLogo
        icoUrl
        logoBackground
        darkLogoBackground
        messageOnLaunch
        messagesOnLaunch
        rotateMessagesOnLaunch
        rotateMessagesOnLaunchInterval
        placeholderMessageOnLoading
        dynamicPlaceholderMessageOnLoading
        customGreetingInstructions
        customConclusionInstructions
        customChartingInstructions
        customSummarisationInstructions
        customImagesInstructions
        customToolingInstructions
        placeholderInputMessage
        openByDefault
        agenticCodingModel
        disclaimer
        showDocumentsReferences
        isDefault
        hasMemory
        hasImages
        promptTopKeywords
        keyWordsForKnowledgeBase
        hasTopicsContext
        hasFunctions
        advancedLanguageDetection
        allowedTopics
        staticDocs
        defaultAnswer
        noKnowledgeDefaultAnswer
        quickQuestions
        recencyImportance
        maxRecencyIncrease
        recencyTopKIncreaseFactor
        stopSequence
        examples {
          question
          answer
        }
        enhancementPassage
        inhibitionPassage
        pertinencePassage
        goals
        qaUrl
        topK
        mode
        showCodeInExecution
        hideReasoning
        charting
        summarisation
        compressor
        docTopK
        minRetrievalScore
        timeSignificance
        hasModeration
        customModerations
        moderationMessage
        languageDetectionConfidence
        maxHistory
        maxTokens
        topicEnhancer
        maxTopics
        blender
        temperature
        seed
        version
        subject
        workspaceID
        createdBy
        updatedBy
        agentFunctions
        isGlobal
        promptBuffering
        functionContext
        plainTextOutput
        chainOfThoughts
        treeOfThoughts
        extendedOutput
        agentType
        agentsPool
        mcps
        maxPlanningSteps
        maxBrowserSteps
        virtualDesktopInstructions
        planningInstructions
        plannerExecutionAttempts
        plannerRequiresApprovalForPlanExecution
        plannerEmailOnApprovalRequest
        plannerEmailOnFailedPlan
        plannerEmailOnCompletedPlan
        plannerAutoAgentSpawn
        plannerRetainsSpawnedAgents
        plannerPromptsAgentsProgrammatically
        plannerDeepThinking
        allowReplanning
        plannerProceedsWhenImprovementsRequired
        plannerApproverEmails
        reviewInstructions
        showReferencesToInternalDocs
        showCitations
        forceJsonOutput
        agenticRAG
        preventWidgetUsage
        allowFeedback
        generateExtendedReport
        showTimeForResponse
        showDetectedLanguage
        showRoutedModel
        isMultiLanguageEnabled
        hasMath
        hasCode
        hasComputer
        hasNER
        restrictedAccess
        restrictedAccessUsers
        splashTitle
        showSplashWhenEmpty
        llmEndpoint
        llmUrl
        llmUrlStatus
        llmUrlType
        llmBaseModel
        llmProvider
        llmTopK
        llmSeed
        forcedTheme
        adverserialProvider
        adverserialModel
        functionCallingProvider
        functionCallingModel
        visionProvider
        visionModel
        browserProvider
        browserModel
        videoGenerationProvider
        videoGenerationModel
        showAgentName
        allowImagesUpload
        allowVideosUpload
        allowAudiosUpload
        allowDocsUpload
        allowImagesGeneration
        baseImageGenerationModel
        maxImagesGenerated
        advancedImageGeneration
        allowVideosGeneration
        allowAudiosGeneration
        allowIntrospection
        voiceFileKey
        audiosGenerationTtsModel
        audiosGenerationVoiceName
        audiosGenerationSpeechMode
        allowInternetSearch
        bannedDomains
        maxUrlsForInternetSearch
        allowDeepInternetSearch
        internetSearchModes
        internetSearchLocation
        autoVoiceMode
        voiceSensitivity
        keywordsWeightInRetrieval
        customCodeExecutionEnvironments
        phoneNumberAsSender
        whatsappNumberAsSender
        emailAsSender
        communicationServices
        channelCallbackDelay
        ephemeralAgent
        parentAgentID
        parentChatID
        minimumSubscriptionType
        clonedAgentID
        clonedAgentIDIcon
        hasContentCreation
        hasEntityExtraction
        department
        metadata
        allowEmailToAgent
        allowedEmails
        agentHiringTemplate
        agentDesktopVM
        agentDesktopPortRange
        agentDesktopCredentials
        agentDesktopBrowser
        allow3dModelGeneration
        agentLongTermMemory
        isLongTermMemoryEnabled
        allowExternalAPI
        forceNewThreadOnProgrammaticRequest
        dynamicModelSelectionInstructions
        contextRelevancyRatio
        reasoningBudget
        reasoningMode
        reasoningEffort
        fnReasoningEffort
        agentFnParams
        canvasEnabled
        advancedCompute
        reRank
        minDeepSearchPagesPercentage
        voiceName
        vadThresholds
        analyticsInstructions
        analyticsCustomFields
        alertIDs
        ragInstructions
        allowAskQuestion
        ragSearchStrategy
        minChunksBeforeCompleteness
        ragCompletenessThreshold
        voiceInstructions
        sttModel
        llmVoiceModel
        ttsModel
        defaultVoiceLanguage
        voiceMinSilenceDuration
        voiceMinEndpointingDelay
        voiceMinInterruptionDuration
        enableVoiceIntermissions
        voiceBackgroundNoise
        sipPhoneNumber
        sipDispatchRuleId
        enableInboundSip
        enableOutboundSip
        enableJsonOutput
        jsonOutputStructure
        predictedPlanJson
        useInterleavedReasoning
        interleavedPreset
        maxTotalToolCalls
        maxConsecutiveSameTool
        maxConsecutiveFailures
        regionalEndpoint
        agentVersion
        agentCategoryType
        maxSessionUoI
        maxSessionTurns
        maxSessionMessage
        showWidgetControls
        allowIpRotationViaProxy
        showToolCallsDetailsInWidget
        allowProxyScraping
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const emailAsSender = /* GraphQL */ `
  query EmailAsSender(
    $emailAsSender: String!
    $sortDirection: ModelSortDirection
    $filter: ModelAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    emailAsSender(
      emailAsSender: $emailAsSender
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        label
        description
        interpolationString
        emoji
        color
        darkColor
        icon
        largeLogo
        icoUrl
        logoBackground
        darkLogoBackground
        messageOnLaunch
        messagesOnLaunch
        rotateMessagesOnLaunch
        rotateMessagesOnLaunchInterval
        placeholderMessageOnLoading
        dynamicPlaceholderMessageOnLoading
        customGreetingInstructions
        customConclusionInstructions
        customChartingInstructions
        customSummarisationInstructions
        customImagesInstructions
        customToolingInstructions
        placeholderInputMessage
        openByDefault
        agenticCodingModel
        disclaimer
        showDocumentsReferences
        isDefault
        hasMemory
        hasImages
        promptTopKeywords
        keyWordsForKnowledgeBase
        hasTopicsContext
        hasFunctions
        advancedLanguageDetection
        allowedTopics
        staticDocs
        defaultAnswer
        noKnowledgeDefaultAnswer
        quickQuestions
        recencyImportance
        maxRecencyIncrease
        recencyTopKIncreaseFactor
        stopSequence
        examples {
          question
          answer
        }
        enhancementPassage
        inhibitionPassage
        pertinencePassage
        goals
        qaUrl
        topK
        mode
        showCodeInExecution
        hideReasoning
        charting
        summarisation
        compressor
        docTopK
        minRetrievalScore
        timeSignificance
        hasModeration
        customModerations
        moderationMessage
        languageDetectionConfidence
        maxHistory
        maxTokens
        topicEnhancer
        maxTopics
        blender
        temperature
        seed
        version
        subject
        workspaceID
        createdBy
        updatedBy
        agentFunctions
        isGlobal
        promptBuffering
        functionContext
        plainTextOutput
        chainOfThoughts
        treeOfThoughts
        extendedOutput
        agentType
        agentsPool
        mcps
        maxPlanningSteps
        maxBrowserSteps
        virtualDesktopInstructions
        planningInstructions
        plannerExecutionAttempts
        plannerRequiresApprovalForPlanExecution
        plannerEmailOnApprovalRequest
        plannerEmailOnFailedPlan
        plannerEmailOnCompletedPlan
        plannerAutoAgentSpawn
        plannerRetainsSpawnedAgents
        plannerPromptsAgentsProgrammatically
        plannerDeepThinking
        allowReplanning
        plannerProceedsWhenImprovementsRequired
        plannerApproverEmails
        reviewInstructions
        showReferencesToInternalDocs
        showCitations
        forceJsonOutput
        agenticRAG
        preventWidgetUsage
        allowFeedback
        generateExtendedReport
        showTimeForResponse
        showDetectedLanguage
        showRoutedModel
        isMultiLanguageEnabled
        hasMath
        hasCode
        hasComputer
        hasNER
        restrictedAccess
        restrictedAccessUsers
        splashTitle
        showSplashWhenEmpty
        llmEndpoint
        llmUrl
        llmUrlStatus
        llmUrlType
        llmBaseModel
        llmProvider
        llmTopK
        llmSeed
        forcedTheme
        adverserialProvider
        adverserialModel
        functionCallingProvider
        functionCallingModel
        visionProvider
        visionModel
        browserProvider
        browserModel
        videoGenerationProvider
        videoGenerationModel
        showAgentName
        allowImagesUpload
        allowVideosUpload
        allowAudiosUpload
        allowDocsUpload
        allowImagesGeneration
        baseImageGenerationModel
        maxImagesGenerated
        advancedImageGeneration
        allowVideosGeneration
        allowAudiosGeneration
        allowIntrospection
        voiceFileKey
        audiosGenerationTtsModel
        audiosGenerationVoiceName
        audiosGenerationSpeechMode
        allowInternetSearch
        bannedDomains
        maxUrlsForInternetSearch
        allowDeepInternetSearch
        internetSearchModes
        internetSearchLocation
        autoVoiceMode
        voiceSensitivity
        keywordsWeightInRetrieval
        customCodeExecutionEnvironments
        phoneNumberAsSender
        whatsappNumberAsSender
        emailAsSender
        communicationServices
        channelCallbackDelay
        ephemeralAgent
        parentAgentID
        parentChatID
        minimumSubscriptionType
        clonedAgentID
        clonedAgentIDIcon
        hasContentCreation
        hasEntityExtraction
        department
        metadata
        allowEmailToAgent
        allowedEmails
        agentHiringTemplate
        agentDesktopVM
        agentDesktopPortRange
        agentDesktopCredentials
        agentDesktopBrowser
        allow3dModelGeneration
        agentLongTermMemory
        isLongTermMemoryEnabled
        allowExternalAPI
        forceNewThreadOnProgrammaticRequest
        dynamicModelSelectionInstructions
        contextRelevancyRatio
        reasoningBudget
        reasoningMode
        reasoningEffort
        fnReasoningEffort
        agentFnParams
        canvasEnabled
        advancedCompute
        reRank
        minDeepSearchPagesPercentage
        voiceName
        vadThresholds
        analyticsInstructions
        analyticsCustomFields
        alertIDs
        ragInstructions
        allowAskQuestion
        ragSearchStrategy
        minChunksBeforeCompleteness
        ragCompletenessThreshold
        voiceInstructions
        sttModel
        llmVoiceModel
        ttsModel
        defaultVoiceLanguage
        voiceMinSilenceDuration
        voiceMinEndpointingDelay
        voiceMinInterruptionDuration
        enableVoiceIntermissions
        voiceBackgroundNoise
        sipPhoneNumber
        sipDispatchRuleId
        enableInboundSip
        enableOutboundSip
        enableJsonOutput
        jsonOutputStructure
        predictedPlanJson
        useInterleavedReasoning
        interleavedPreset
        maxTotalToolCalls
        maxConsecutiveSameTool
        maxConsecutiveFailures
        regionalEndpoint
        agentVersion
        agentCategoryType
        maxSessionUoI
        maxSessionTurns
        maxSessionMessage
        showWidgetControls
        allowIpRotationViaProxy
        showToolCallsDetailsInWidget
        allowProxyScraping
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getAgentByPhoneNumber = /* GraphQL */ `
  query GetAgentByPhoneNumber(
    $sipPhoneNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    GetAgentByPhoneNumber(
      sipPhoneNumber: $sipPhoneNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        label
        description
        interpolationString
        emoji
        color
        darkColor
        icon
        largeLogo
        icoUrl
        logoBackground
        darkLogoBackground
        messageOnLaunch
        messagesOnLaunch
        rotateMessagesOnLaunch
        rotateMessagesOnLaunchInterval
        placeholderMessageOnLoading
        dynamicPlaceholderMessageOnLoading
        customGreetingInstructions
        customConclusionInstructions
        customChartingInstructions
        customSummarisationInstructions
        customImagesInstructions
        customToolingInstructions
        placeholderInputMessage
        openByDefault
        agenticCodingModel
        disclaimer
        showDocumentsReferences
        isDefault
        hasMemory
        hasImages
        promptTopKeywords
        keyWordsForKnowledgeBase
        hasTopicsContext
        hasFunctions
        advancedLanguageDetection
        allowedTopics
        staticDocs
        defaultAnswer
        noKnowledgeDefaultAnswer
        quickQuestions
        recencyImportance
        maxRecencyIncrease
        recencyTopKIncreaseFactor
        stopSequence
        examples {
          question
          answer
        }
        enhancementPassage
        inhibitionPassage
        pertinencePassage
        goals
        qaUrl
        topK
        mode
        showCodeInExecution
        hideReasoning
        charting
        summarisation
        compressor
        docTopK
        minRetrievalScore
        timeSignificance
        hasModeration
        customModerations
        moderationMessage
        languageDetectionConfidence
        maxHistory
        maxTokens
        topicEnhancer
        maxTopics
        blender
        temperature
        seed
        version
        subject
        workspaceID
        createdBy
        updatedBy
        agentFunctions
        isGlobal
        promptBuffering
        functionContext
        plainTextOutput
        chainOfThoughts
        treeOfThoughts
        extendedOutput
        agentType
        agentsPool
        mcps
        maxPlanningSteps
        maxBrowserSteps
        virtualDesktopInstructions
        planningInstructions
        plannerExecutionAttempts
        plannerRequiresApprovalForPlanExecution
        plannerEmailOnApprovalRequest
        plannerEmailOnFailedPlan
        plannerEmailOnCompletedPlan
        plannerAutoAgentSpawn
        plannerRetainsSpawnedAgents
        plannerPromptsAgentsProgrammatically
        plannerDeepThinking
        allowReplanning
        plannerProceedsWhenImprovementsRequired
        plannerApproverEmails
        reviewInstructions
        showReferencesToInternalDocs
        showCitations
        forceJsonOutput
        agenticRAG
        preventWidgetUsage
        allowFeedback
        generateExtendedReport
        showTimeForResponse
        showDetectedLanguage
        showRoutedModel
        isMultiLanguageEnabled
        hasMath
        hasCode
        hasComputer
        hasNER
        restrictedAccess
        restrictedAccessUsers
        splashTitle
        showSplashWhenEmpty
        llmEndpoint
        llmUrl
        llmUrlStatus
        llmUrlType
        llmBaseModel
        llmProvider
        llmTopK
        llmSeed
        forcedTheme
        adverserialProvider
        adverserialModel
        functionCallingProvider
        functionCallingModel
        visionProvider
        visionModel
        browserProvider
        browserModel
        videoGenerationProvider
        videoGenerationModel
        showAgentName
        allowImagesUpload
        allowVideosUpload
        allowAudiosUpload
        allowDocsUpload
        allowImagesGeneration
        baseImageGenerationModel
        maxImagesGenerated
        advancedImageGeneration
        allowVideosGeneration
        allowAudiosGeneration
        allowIntrospection
        voiceFileKey
        audiosGenerationTtsModel
        audiosGenerationVoiceName
        audiosGenerationSpeechMode
        allowInternetSearch
        bannedDomains
        maxUrlsForInternetSearch
        allowDeepInternetSearch
        internetSearchModes
        internetSearchLocation
        autoVoiceMode
        voiceSensitivity
        keywordsWeightInRetrieval
        customCodeExecutionEnvironments
        phoneNumberAsSender
        whatsappNumberAsSender
        emailAsSender
        communicationServices
        channelCallbackDelay
        ephemeralAgent
        parentAgentID
        parentChatID
        minimumSubscriptionType
        clonedAgentID
        clonedAgentIDIcon
        hasContentCreation
        hasEntityExtraction
        department
        metadata
        allowEmailToAgent
        allowedEmails
        agentHiringTemplate
        agentDesktopVM
        agentDesktopPortRange
        agentDesktopCredentials
        agentDesktopBrowser
        allow3dModelGeneration
        agentLongTermMemory
        isLongTermMemoryEnabled
        allowExternalAPI
        forceNewThreadOnProgrammaticRequest
        dynamicModelSelectionInstructions
        contextRelevancyRatio
        reasoningBudget
        reasoningMode
        reasoningEffort
        fnReasoningEffort
        agentFnParams
        canvasEnabled
        advancedCompute
        reRank
        minDeepSearchPagesPercentage
        voiceName
        vadThresholds
        analyticsInstructions
        analyticsCustomFields
        alertIDs
        ragInstructions
        allowAskQuestion
        ragSearchStrategy
        minChunksBeforeCompleteness
        ragCompletenessThreshold
        voiceInstructions
        sttModel
        llmVoiceModel
        ttsModel
        defaultVoiceLanguage
        voiceMinSilenceDuration
        voiceMinEndpointingDelay
        voiceMinInterruptionDuration
        enableVoiceIntermissions
        voiceBackgroundNoise
        sipPhoneNumber
        sipDispatchRuleId
        enableInboundSip
        enableOutboundSip
        enableJsonOutput
        jsonOutputStructure
        predictedPlanJson
        useInterleavedReasoning
        interleavedPreset
        maxTotalToolCalls
        maxConsecutiveSameTool
        maxConsecutiveFailures
        regionalEndpoint
        agentVersion
        agentCategoryType
        maxSessionUoI
        maxSessionTurns
        maxSessionMessage
        showWidgetControls
        allowIpRotationViaProxy
        showToolCallsDetailsInWidget
        allowProxyScraping
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getAgentFunction = /* GraphQL */ `
  query GetAgentFunction($id: ID!) {
    getAgentFunction(id: $id) {
      id
      name
      description
      parameters
      model
      url
      requestType
      authorisationType
      dependsOnBeforeExecution
      dependsOnAfterExecution
      authorisationKey
      authorisationID
      paramsAsPath
      scope
      jsonPathExtractor
      headers
      staticArgs
      customExecutionCode
      isMCPServer
      isCallbackFn
      isDatabaseScript
      isHtmlFn
      isChatFn
      isHandOffFn
      isCodeTemplate
      isAgentSkill
      codeExecutionEnvironmentID
      onFnCall
      handOffAgent
      handOffToOriginalAgentOnCompletion
      handOffToOriginalAgentOnFailure
      handOffAgentOnCompletion
      handOffAgentOnFailure
      agentSkillScript
      chatScript
      chatAction
      htmlUrl
      htmlScript
      isHtmlRedirectFn
      htmlFormOnSuccessfulSubmitMessage
      htmlFormOnFailedSubmitMessage
      dbSchemaMetadata
      preExecutionScript
      postExecutionScript
      dbScript
      dbConnectionID
      preExecutionFnID
      preExecutionMapping
      OAuthConnectionID
      handedOffToHumanOnCall
      graphqlQuery
      graphqlMutation
      graphqlOperationName
      usersToHandOffTo
      workspaceID
      createdBy
      updatedBy
      isGlobal
      functionVersion
      functionType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listAgentFunctions = /* GraphQL */ `
  query ListAgentFunctions(
    $filter: ModelAgentFunctionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentFunctions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        parameters
        model
        url
        requestType
        authorisationType
        dependsOnBeforeExecution
        dependsOnAfterExecution
        authorisationKey
        authorisationID
        paramsAsPath
        scope
        jsonPathExtractor
        headers
        staticArgs
        customExecutionCode
        isMCPServer
        isCallbackFn
        isDatabaseScript
        isHtmlFn
        isChatFn
        isHandOffFn
        isCodeTemplate
        isAgentSkill
        codeExecutionEnvironmentID
        onFnCall
        handOffAgent
        handOffToOriginalAgentOnCompletion
        handOffToOriginalAgentOnFailure
        handOffAgentOnCompletion
        handOffAgentOnFailure
        agentSkillScript
        chatScript
        chatAction
        htmlUrl
        htmlScript
        isHtmlRedirectFn
        htmlFormOnSuccessfulSubmitMessage
        htmlFormOnFailedSubmitMessage
        dbSchemaMetadata
        preExecutionScript
        postExecutionScript
        dbScript
        dbConnectionID
        preExecutionFnID
        preExecutionMapping
        OAuthConnectionID
        handedOffToHumanOnCall
        graphqlQuery
        graphqlMutation
        graphqlOperationName
        usersToHandOffTo
        workspaceID
        createdBy
        updatedBy
        isGlobal
        functionVersion
        functionType
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncAgentFunctions = /* GraphQL */ `
  query SyncAgentFunctions(
    $filter: ModelAgentFunctionFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAgentFunctions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        parameters
        model
        url
        requestType
        authorisationType
        dependsOnBeforeExecution
        dependsOnAfterExecution
        authorisationKey
        authorisationID
        paramsAsPath
        scope
        jsonPathExtractor
        headers
        staticArgs
        customExecutionCode
        isMCPServer
        isCallbackFn
        isDatabaseScript
        isHtmlFn
        isChatFn
        isHandOffFn
        isCodeTemplate
        isAgentSkill
        codeExecutionEnvironmentID
        onFnCall
        handOffAgent
        handOffToOriginalAgentOnCompletion
        handOffToOriginalAgentOnFailure
        handOffAgentOnCompletion
        handOffAgentOnFailure
        agentSkillScript
        chatScript
        chatAction
        htmlUrl
        htmlScript
        isHtmlRedirectFn
        htmlFormOnSuccessfulSubmitMessage
        htmlFormOnFailedSubmitMessage
        dbSchemaMetadata
        preExecutionScript
        postExecutionScript
        dbScript
        dbConnectionID
        preExecutionFnID
        preExecutionMapping
        OAuthConnectionID
        handedOffToHumanOnCall
        graphqlQuery
        graphqlMutation
        graphqlOperationName
        usersToHandOffTo
        workspaceID
        createdBy
        updatedBy
        isGlobal
        functionVersion
        functionType
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const functionsByWorkspace = /* GraphQL */ `
  query FunctionsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAgentFunctionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    functionsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        parameters
        model
        url
        requestType
        authorisationType
        dependsOnBeforeExecution
        dependsOnAfterExecution
        authorisationKey
        authorisationID
        paramsAsPath
        scope
        jsonPathExtractor
        headers
        staticArgs
        customExecutionCode
        isMCPServer
        isCallbackFn
        isDatabaseScript
        isHtmlFn
        isChatFn
        isHandOffFn
        isCodeTemplate
        isAgentSkill
        codeExecutionEnvironmentID
        onFnCall
        handOffAgent
        handOffToOriginalAgentOnCompletion
        handOffToOriginalAgentOnFailure
        handOffAgentOnCompletion
        handOffAgentOnFailure
        agentSkillScript
        chatScript
        chatAction
        htmlUrl
        htmlScript
        isHtmlRedirectFn
        htmlFormOnSuccessfulSubmitMessage
        htmlFormOnFailedSubmitMessage
        dbSchemaMetadata
        preExecutionScript
        postExecutionScript
        dbScript
        dbConnectionID
        preExecutionFnID
        preExecutionMapping
        OAuthConnectionID
        handedOffToHumanOnCall
        graphqlQuery
        graphqlMutation
        graphqlOperationName
        usersToHandOffTo
        workspaceID
        createdBy
        updatedBy
        isGlobal
        functionVersion
        functionType
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getAuthorisation = /* GraphQL */ `
  query GetAuthorisation($id: ID!) {
    getAuthorisation(id: $id) {
      id
      name
      tokenSecret
      description
      scope
      grantType
      clientId
      clientSecret
      authorizationBaseUrl
      staticArgs
      tokenBaseUrl
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listAuthorisations = /* GraphQL */ `
  query ListAuthorisations(
    $filter: ModelAuthorisationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAuthorisations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        tokenSecret
        description
        scope
        grantType
        clientId
        clientSecret
        authorizationBaseUrl
        staticArgs
        tokenBaseUrl
        type
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncAuthorisations = /* GraphQL */ `
  query SyncAuthorisations(
    $filter: ModelAuthorisationFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAuthorisations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        tokenSecret
        description
        scope
        grantType
        clientId
        clientSecret
        authorizationBaseUrl
        staticArgs
        tokenBaseUrl
        type
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const authorisationsByWorkspace = /* GraphQL */ `
  query AuthorisationsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAuthorisationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    authorisationsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tokenSecret
        description
        scope
        grantType
        clientId
        clientSecret
        authorizationBaseUrl
        staticArgs
        tokenBaseUrl
        type
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getHosting = /* GraphQL */ `
  query GetHosting($id: ID!) {
    getHosting(id: $id) {
      id
      name
      description
      tokenSecret
      endpoint
      modelName
      baseModel
      customModel
      apiVersion
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listHostings = /* GraphQL */ `
  query ListHostings(
    $filter: ModelHostingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHostings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        tokenSecret
        endpoint
        modelName
        baseModel
        customModel
        apiVersion
        type
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncHostings = /* GraphQL */ `
  query SyncHostings(
    $filter: ModelHostingFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncHostings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        tokenSecret
        endpoint
        modelName
        baseModel
        customModel
        apiVersion
        type
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const hostingsByWorkspace = /* GraphQL */ `
  query HostingsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelHostingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    HostingsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        tokenSecret
        endpoint
        modelName
        baseModel
        customModel
        apiVersion
        type
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getMCP = /* GraphQL */ `
  query GetMCP($id: ID!) {
    getMCP(id: $id) {
      id
      name
      version
      description
      tokenSecret
      endpoint
      toolsAvailable
      resourcesAvailable
      promptsAvailable
      workspaceID
      createdBy
      updatedBy
      isGlobal
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listMCPS = /* GraphQL */ `
  query ListMCPS(
    $filter: ModelMCPFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMCPS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        version
        description
        tokenSecret
        endpoint
        toolsAvailable
        resourcesAvailable
        promptsAvailable
        workspaceID
        createdBy
        updatedBy
        isGlobal
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncMCPS = /* GraphQL */ `
  query SyncMCPS(
    $filter: ModelMCPFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncMCPS(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        version
        description
        tokenSecret
        endpoint
        toolsAvailable
        resourcesAvailable
        promptsAvailable
        workspaceID
        createdBy
        updatedBy
        isGlobal
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const mCPByWorkspace = /* GraphQL */ `
  query MCPByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelMCPFilterInput
    $limit: Int
    $nextToken: String
  ) {
    MCPByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        version
        description
        tokenSecret
        endpoint
        toolsAvailable
        resourcesAvailable
        promptsAvailable
        workspaceID
        createdBy
        updatedBy
        isGlobal
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getDatabaseConnection = /* GraphQL */ `
  query GetDatabaseConnection($id: ID!) {
    getDatabaseConnection(id: $id) {
      id
      name
      description
      type
      host
      port
      username
      passwordSecret
      database
      schema
      ssl
      ssh
      sshHost
      sshPort
      sshUsername
      sshPasswordSecret
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listDatabaseConnections = /* GraphQL */ `
  query ListDatabaseConnections(
    $filter: ModelDatabaseConnectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatabaseConnections(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        host
        port
        username
        passwordSecret
        database
        schema
        ssl
        ssh
        sshHost
        sshPort
        sshUsername
        sshPasswordSecret
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncDatabaseConnections = /* GraphQL */ `
  query SyncDatabaseConnections(
    $filter: ModelDatabaseConnectionFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDatabaseConnections(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        type
        host
        port
        username
        passwordSecret
        database
        schema
        ssl
        ssh
        sshHost
        sshPort
        sshUsername
        sshPasswordSecret
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const connectionsByWorkspace = /* GraphQL */ `
  query ConnectionsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDatabaseConnectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    connectionsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        host
        port
        username
        passwordSecret
        database
        schema
        ssl
        ssh
        sshHost
        sshPort
        sshUsername
        sshPasswordSecret
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getUserNotification = /* GraphQL */ `
  query GetUserNotification($id: ID!) {
    getUserNotification(id: $id) {
      id
      type
      title
      description
      userID
      metadata
      createdBy
      updatedBy
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listUserNotifications = /* GraphQL */ `
  query ListUserNotifications(
    $filter: ModelUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserNotifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        title
        description
        userID
        metadata
        createdBy
        updatedBy
        workspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncUserNotifications = /* GraphQL */ `
  query SyncUserNotifications(
    $filter: ModelUserNotificationFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserNotifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        type
        title
        description
        userID
        metadata
        createdBy
        updatedBy
        workspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const notificationsByUsers = /* GraphQL */ `
  query NotificationsByUsers(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByUsers(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        title
        description
        userID
        metadata
        createdBy
        updatedBy
        workspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const notificationsByWorkspace = /* GraphQL */ `
  query NotificationsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        title
        description
        userID
        metadata
        createdBy
        updatedBy
        workspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getAlert = /* GraphQL */ `
  query GetAlert($id: ID!) {
    getAlert(id: $id) {
      id
      name
      description
      triggerType
      conditions
      severity
      isActive
      cooldownMinutes
      lastTriggeredAt
      agentID
      recipients
      recipientEmails
      notifyEmail
      notifyPush
      notifyInApp
      notifyWebhook
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listAlerts = /* GraphQL */ `
  query ListAlerts(
    $filter: ModelAlertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlerts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        triggerType
        conditions
        severity
        isActive
        cooldownMinutes
        lastTriggeredAt
        agentID
        recipients
        recipientEmails
        notifyEmail
        notifyPush
        notifyInApp
        notifyWebhook
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncAlerts = /* GraphQL */ `
  query SyncAlerts(
    $filter: ModelAlertFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAlerts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        triggerType
        conditions
        severity
        isActive
        cooldownMinutes
        lastTriggeredAt
        agentID
        recipients
        recipientEmails
        notifyEmail
        notifyPush
        notifyInApp
        notifyWebhook
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const alertsByAgent = /* GraphQL */ `
  query AlertsByAgent(
    $agentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAlertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alertsByAgent(
      agentID: $agentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        triggerType
        conditions
        severity
        isActive
        cooldownMinutes
        lastTriggeredAt
        agentID
        recipients
        recipientEmails
        notifyEmail
        notifyPush
        notifyInApp
        notifyWebhook
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const alertsByWorkspace = /* GraphQL */ `
  query AlertsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAlertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alertsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        triggerType
        conditions
        severity
        isActive
        cooldownMinutes
        lastTriggeredAt
        agentID
        recipients
        recipientEmails
        notifyEmail
        notifyPush
        notifyInApp
        notifyWebhook
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getVirtualMachine = /* GraphQL */ `
  query GetVirtualMachine($id: ID!) {
    getVirtualMachine(id: $id) {
      id
      name
      description
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listVirtualMachines = /* GraphQL */ `
  query ListVirtualMachines(
    $filter: ModelVirtualMachineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVirtualMachines(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        ip
        workspaceID
        port
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncVirtualMachines = /* GraphQL */ `
  query SyncVirtualMachines(
    $filter: ModelVirtualMachineFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncVirtualMachines(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        ip
        workspaceID
        port
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const virtualMachinesByWorkspace = /* GraphQL */ `
  query VirtualMachinesByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVirtualMachineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    virtualMachinesByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        ip
        workspaceID
        port
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getCustomExecutionEnvironment = /* GraphQL */ `
  query GetCustomExecutionEnvironment($id: ID!) {
    getCustomExecutionEnvironment(id: $id) {
      id
      name
      description
      functionName
      availableLibraries
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      isGlobal
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listCustomExecutionEnvironments = /* GraphQL */ `
  query ListCustomExecutionEnvironments(
    $filter: ModelCustomExecutionEnvironmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomExecutionEnvironments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        functionName
        availableLibraries
        ip
        workspaceID
        port
        metadata
        createdBy
        updatedBy
        isGlobal
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncCustomExecutionEnvironments = /* GraphQL */ `
  query SyncCustomExecutionEnvironments(
    $filter: ModelCustomExecutionEnvironmentFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCustomExecutionEnvironments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        functionName
        availableLibraries
        ip
        workspaceID
        port
        metadata
        createdBy
        updatedBy
        isGlobal
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const customExecutionEnvironmentByWorkspace = /* GraphQL */ `
  query CustomExecutionEnvironmentByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCustomExecutionEnvironmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customExecutionEnvironmentByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        functionName
        availableLibraries
        ip
        workspaceID
        port
        metadata
        createdBy
        updatedBy
        isGlobal
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getSite = /* GraphQL */ `
  query GetSite($id: ID!) {
    getSite(id: $id) {
      id
      name
      description
      url
      customSitemap
      workspaceID
      topics
      status
      lastValidationDate
      lastValidationRequested
      validationToken
      allowedPaths
      siteTree
      lastScraped
      skipOwnerValidation
      useProxy
      completion_percentage
      extractImages
      freeRoaming
      scrapingCycle
      imgRetrievalPrompt
      metadata
      createdBy
      updatedBy
      scapablePages
      scrapedPagesCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listSites = /* GraphQL */ `
  query ListSites(
    $filter: ModelSiteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSites(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        url
        customSitemap
        workspaceID
        topics
        status
        lastValidationDate
        lastValidationRequested
        validationToken
        allowedPaths
        siteTree
        lastScraped
        skipOwnerValidation
        useProxy
        completion_percentage
        extractImages
        freeRoaming
        scrapingCycle
        imgRetrievalPrompt
        metadata
        createdBy
        updatedBy
        scapablePages
        scrapedPagesCount
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncSites = /* GraphQL */ `
  query SyncSites(
    $filter: ModelSiteFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSites(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        url
        customSitemap
        workspaceID
        topics
        status
        lastValidationDate
        lastValidationRequested
        validationToken
        allowedPaths
        siteTree
        lastScraped
        skipOwnerValidation
        useProxy
        completion_percentage
        extractImages
        freeRoaming
        scrapingCycle
        imgRetrievalPrompt
        metadata
        createdBy
        updatedBy
        scapablePages
        scrapedPagesCount
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const sitesByWorkspace = /* GraphQL */ `
  query SitesByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSiteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sitesByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        url
        customSitemap
        workspaceID
        topics
        status
        lastValidationDate
        lastValidationRequested
        validationToken
        allowedPaths
        siteTree
        lastScraped
        skipOwnerValidation
        useProxy
        completion_percentage
        extractImages
        freeRoaming
        scrapingCycle
        imgRetrievalPrompt
        metadata
        createdBy
        updatedBy
        scapablePages
        scrapedPagesCount
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const siteByValidationToken = /* GraphQL */ `
  query SiteByValidationToken(
    $validationToken: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSiteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    siteByValidationToken(
      validationToken: $validationToken
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        url
        customSitemap
        workspaceID
        topics
        status
        lastValidationDate
        lastValidationRequested
        validationToken
        allowedPaths
        siteTree
        lastScraped
        skipOwnerValidation
        useProxy
        completion_percentage
        extractImages
        freeRoaming
        scrapingCycle
        imgRetrievalPrompt
        metadata
        createdBy
        updatedBy
        scapablePages
        scrapedPagesCount
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getEntityAI = /* GraphQL */ `
  query GetEntityAI($id: ID!) {
    getEntityAI(id: $id) {
      id
      owner
      label
      type
      description
      emoji
      parentEntity
      backgroundColor
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listEntityAIS = /* GraphQL */ `
  query ListEntityAIS(
    $filter: ModelEntityAIFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEntityAIS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        label
        type
        description
        emoji
        parentEntity
        backgroundColor
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncEntityAIS = /* GraphQL */ `
  query SyncEntityAIS(
    $filter: ModelEntityAIFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEntityAIS(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        owner
        label
        type
        description
        emoji
        parentEntity
        backgroundColor
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const entitiesByWorkspace = /* GraphQL */ `
  query EntitiesByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEntityAIFilterInput
    $limit: Int
    $nextToken: String
  ) {
    entitiesByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        label
        type
        description
        emoji
        parentEntity
        backgroundColor
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getTrainingLog = /* GraphQL */ `
  query GetTrainingLog($id: ID!) {
    getTrainingLog(id: $id) {
      id
      owner
      name
      description
      status
      trainingIterations
      lastActivation
      duration
      trainingMeta
      trainingConfig
      workspaceID
      type
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listTrainingLogs = /* GraphQL */ `
  query ListTrainingLogs(
    $filter: ModelTrainingLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTrainingLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        name
        description
        status
        trainingIterations
        lastActivation
        duration
        trainingMeta
        trainingConfig
        workspaceID
        type
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncTrainingLogs = /* GraphQL */ `
  query SyncTrainingLogs(
    $filter: ModelTrainingLogFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTrainingLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        owner
        name
        description
        status
        trainingIterations
        lastActivation
        duration
        trainingMeta
        trainingConfig
        workspaceID
        type
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const trainingLogsByStatus = /* GraphQL */ `
  query TrainingLogsByStatus(
    $status: TrainingStatus!
    $sortDirection: ModelSortDirection
    $filter: ModelTrainingLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    trainingLogsByStatus(
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        name
        description
        status
        trainingIterations
        lastActivation
        duration
        trainingMeta
        trainingConfig
        workspaceID
        type
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const trainingLogsByWorkspace = /* GraphQL */ `
  query TrainingLogsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTrainingLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    trainingLogsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        name
        description
        status
        trainingIterations
        lastActivation
        duration
        trainingMeta
        trainingConfig
        workspaceID
        type
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getBatchJobLog = /* GraphQL */ `
  query GetBatchJobLog($id: ID!) {
    getBatchJobLog(id: $id) {
      id
      owner
      name
      description
      status
      duration
      batchMeta
      batchConfig
      batchOutput
      workspaceID
      type
      createdBy
      updatedBy
      benchmarkID
      agentID
      agentVersion
      reviewerAgentID
      reviewerAgentVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listBatchJobLogs = /* GraphQL */ `
  query ListBatchJobLogs(
    $filter: ModelBatchJobLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBatchJobLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        name
        description
        status
        duration
        batchMeta
        batchConfig
        batchOutput
        workspaceID
        type
        createdBy
        updatedBy
        benchmarkID
        agentID
        agentVersion
        reviewerAgentID
        reviewerAgentVersion
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncBatchJobLogs = /* GraphQL */ `
  query SyncBatchJobLogs(
    $filter: ModelBatchJobLogFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncBatchJobLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        owner
        name
        description
        status
        duration
        batchMeta
        batchConfig
        batchOutput
        workspaceID
        type
        createdBy
        updatedBy
        benchmarkID
        agentID
        agentVersion
        reviewerAgentID
        reviewerAgentVersion
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const batchJobLogsByWorkspace = /* GraphQL */ `
  query BatchJobLogsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBatchJobLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    batchJobLogsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        name
        description
        status
        duration
        batchMeta
        batchConfig
        batchOutput
        workspaceID
        type
        createdBy
        updatedBy
        benchmarkID
        agentID
        agentVersion
        reviewerAgentID
        reviewerAgentVersion
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getAppLog = /* GraphQL */ `
  query GetAppLog($id: ID!) {
    getAppLog(id: $id) {
      id
      owner
      type
      filename
      event
      status
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listAppLogs = /* GraphQL */ `
  query ListAppLogs(
    $filter: ModelAppLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        type
        filename
        event
        status
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncAppLogs = /* GraphQL */ `
  query SyncAppLogs(
    $filter: ModelAppLogFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAppLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        owner
        type
        filename
        event
        status
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const appLogsByWorkspace = /* GraphQL */ `
  query AppLogsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAppLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    appLogsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        type
        filename
        event
        status
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getRequestLog = /* GraphQL */ `
  query GetRequestLog($id: ID!) {
    getRequestLog(id: $id) {
      id
      srtKey
      type
      status
      words
      tokens
      sentences
      artifactsNumber
      modelType
      outputType
      inputTokens
      outputTokens
      totalTokens
      inputCostUSD
      outputCostUSD
      description
      totalCostUSD
      cachedInputTokens
      cacheHitRate
      cacheSavingsUSD
      callType
      callPurpose
      latencyMs
      agentID
      workspaceID
      createdBy
      updatedBy
      creationTime
      isFromToothFairy
      userID
      supportHours
      chatID
      messageID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listRequestLogs = /* GraphQL */ `
  query ListRequestLogs(
    $filter: ModelRequestLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRequestLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        srtKey
        type
        status
        words
        tokens
        sentences
        artifactsNumber
        modelType
        outputType
        inputTokens
        outputTokens
        totalTokens
        inputCostUSD
        outputCostUSD
        description
        totalCostUSD
        cachedInputTokens
        cacheHitRate
        cacheSavingsUSD
        callType
        callPurpose
        latencyMs
        agentID
        workspaceID
        createdBy
        updatedBy
        creationTime
        isFromToothFairy
        userID
        supportHours
        chatID
        messageID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncRequestLogs = /* GraphQL */ `
  query SyncRequestLogs(
    $filter: ModelRequestLogFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRequestLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        srtKey
        type
        status
        words
        tokens
        sentences
        artifactsNumber
        modelType
        outputType
        inputTokens
        outputTokens
        totalTokens
        inputCostUSD
        outputCostUSD
        description
        totalCostUSD
        cachedInputTokens
        cacheHitRate
        cacheSavingsUSD
        callType
        callPurpose
        latencyMs
        agentID
        workspaceID
        createdBy
        updatedBy
        creationTime
        isFromToothFairy
        userID
        supportHours
        chatID
        messageID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const requestsByMonthAndWorkspace = /* GraphQL */ `
  query RequestsByMonthAndWorkspace(
    $srtKey: String!
    $sortDirection: ModelSortDirection
    $filter: ModelRequestLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requestsByMonthAndWorkspace(
      srtKey: $srtKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        srtKey
        type
        status
        words
        tokens
        sentences
        artifactsNumber
        modelType
        outputType
        inputTokens
        outputTokens
        totalTokens
        inputCostUSD
        outputCostUSD
        description
        totalCostUSD
        cachedInputTokens
        cacheHitRate
        cacheSavingsUSD
        callType
        callPurpose
        latencyMs
        agentID
        workspaceID
        createdBy
        updatedBy
        creationTime
        isFromToothFairy
        userID
        supportHours
        chatID
        messageID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const requestLogsByWorkspace = /* GraphQL */ `
  query RequestLogsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRequestLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requestLogsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        srtKey
        type
        status
        words
        tokens
        sentences
        artifactsNumber
        modelType
        outputType
        inputTokens
        outputTokens
        totalTokens
        inputCostUSD
        outputCostUSD
        description
        totalCostUSD
        cachedInputTokens
        cacheHitRate
        cacheSavingsUSD
        callType
        callPurpose
        latencyMs
        agentID
        workspaceID
        createdBy
        updatedBy
        creationTime
        isFromToothFairy
        userID
        supportHours
        chatID
        messageID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const requestLogsByChat = /* GraphQL */ `
  query RequestLogsByChat(
    $chatID: ID!
    $creationTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRequestLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requestLogsByChat(
      chatID: $chatID
      creationTime: $creationTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        srtKey
        type
        status
        words
        tokens
        sentences
        artifactsNumber
        modelType
        outputType
        inputTokens
        outputTokens
        totalTokens
        inputCostUSD
        outputCostUSD
        description
        totalCostUSD
        cachedInputTokens
        cacheHitRate
        cacheSavingsUSD
        callType
        callPurpose
        latencyMs
        agentID
        workspaceID
        createdBy
        updatedBy
        creationTime
        isFromToothFairy
        userID
        supportHours
        chatID
        messageID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const requestLogsByMessage = /* GraphQL */ `
  query RequestLogsByMessage(
    $messageID: ID!
    $creationTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRequestLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requestLogsByMessage(
      messageID: $messageID
      creationTime: $creationTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        srtKey
        type
        status
        words
        tokens
        sentences
        artifactsNumber
        modelType
        outputType
        inputTokens
        outputTokens
        totalTokens
        inputCostUSD
        outputCostUSD
        description
        totalCostUSD
        cachedInputTokens
        cacheHitRate
        cacheSavingsUSD
        callType
        callPurpose
        latencyMs
        agentID
        workspaceID
        createdBy
        updatedBy
        creationTime
        isFromToothFairy
        userID
        supportHours
        chatID
        messageID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getOutputStream = /* GraphQL */ `
  query GetOutputStream($id: ID!) {
    getOutputStream(id: $id) {
      id
      content
      t_content
      prompt
      t_prompt
      workspaceID
      type
      status
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      adminChecked
      autoTune
      scoring
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listOutputStreams = /* GraphQL */ `
  query ListOutputStreams(
    $filter: ModelOutputStreamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutputStreams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        t_content
        prompt
        t_prompt
        workspaceID
        type
        status
        humanFeedback
        humanFeedbackComment
        humanFeedbackType
        humanFeedbackSubType
        humanFeedbackProvidedBy
        adminResolution
        adminChecked
        autoTune
        scoring
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncOutputStreams = /* GraphQL */ `
  query SyncOutputStreams(
    $filter: ModelOutputStreamFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncOutputStreams(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        content
        t_content
        prompt
        t_prompt
        workspaceID
        type
        status
        humanFeedback
        humanFeedbackComment
        humanFeedbackType
        humanFeedbackSubType
        humanFeedbackProvidedBy
        adminResolution
        adminChecked
        autoTune
        scoring
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const streamsByWorkspace = /* GraphQL */ `
  query StreamsByWorkspace(
    $workspaceID: ID!
    $humanFeedback: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutputStreamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    streamsByWorkspace(
      workspaceID: $workspaceID
      humanFeedback: $humanFeedback
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        t_content
        prompt
        t_prompt
        workspaceID
        type
        status
        humanFeedback
        humanFeedbackComment
        humanFeedbackType
        humanFeedbackSubType
        humanFeedbackProvidedBy
        adminResolution
        adminChecked
        autoTune
        scoring
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getFolders = /* GraphQL */ `
  query GetFolders($id: ID!) {
    getFolders(id: $id) {
      id
      owner
      name
      description
      emoji
      status
      allowedTopics
      parent
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listFolders = /* GraphQL */ `
  query ListFolders(
    $filter: ModelFoldersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFolders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        name
        description
        emoji
        status
        allowedTopics
        parent
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncFolders = /* GraphQL */ `
  query SyncFolders(
    $filter: ModelFoldersFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncFolders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        owner
        name
        description
        emoji
        status
        allowedTopics
        parent
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const foldersByWorkspaceID = /* GraphQL */ `
  query FoldersByWorkspaceID(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFoldersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    foldersByWorkspaceID(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        name
        description
        emoji
        status
        allowedTopics
        parent
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getDictionaryItem = /* GraphQL */ `
  query GetDictionaryItem($id: ID!) {
    getDictionaryItem(id: $id) {
      id
      owner
      sourceLanguage
      targetLanguage
      sourceText
      targetText
      workspaceID
      pos
      description
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listDictionaryItems = /* GraphQL */ `
  query ListDictionaryItems(
    $filter: ModelDictionaryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDictionaryItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        sourceLanguage
        targetLanguage
        sourceText
        targetText
        workspaceID
        pos
        description
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncDictionaryItems = /* GraphQL */ `
  query SyncDictionaryItems(
    $filter: ModelDictionaryItemFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDictionaryItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        owner
        sourceLanguage
        targetLanguage
        sourceText
        targetText
        workspaceID
        pos
        description
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const dictionaryItemsByWorkspaceID = /* GraphQL */ `
  query DictionaryItemsByWorkspaceID(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDictionaryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dictionaryItemsByWorkspaceID(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        sourceLanguage
        targetLanguage
        sourceText
        targetText
        workspaceID
        pos
        description
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getChat = /* GraphQL */ `
  query GetChat($id: ID!) {
    getChat(id: $id) {
      id
      owner
      name
      description
      status {
        status
        lastUpdated
      }
      workspaceID
      creationTime
      createdBy
      updatedBy
      visibility
      isAIReplying
      activeMessageForAI
      messages {
        items {
          id
          role
          chatID
          text
          t_text
          t_text_summary
          createdAt
          creationTime
          updatedAt
          scoring
          embeddingId
          humanFeedback
          humanFeedbackComment
          humanFeedbackType
          humanFeedbackSubType
          humanFeedbackProvidedBy
          adminResolution
          prevMessage
          prevMessagePosEq
          prevMessageNegEq
          correctContext
          correctAnswer
          adminChecked
          autoTune
          userID
          agentID
          humanFeedbackForInstruction
          images
          audios
          videos
          files
          imagesText
          audiosText
          videosText
          filesText
          isAI
          messageType
          status
          metadata
          callbackMetadata
          workspaceID
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      chatHistory
      topics
      documentId
      primaryRole
      primaryAgent
      plannerAgent
      forcePlannerStop
      allowMultipleRoles
      handedOffToHuman
      roles
      language
      summary
      caseId
      customerId
      caseInfo
      customerInfo
      projectId
      projectInfo
      genericEntityId
      genericEntityInfo
      metadata
      userFeedbackOnSteps
      channelSettings
      sourceJobID
      canvasID
      canvasOperations
      canvasLastChangesetID
      canvasLastChangesetTimestamp
      externalParticipantId
      piiDetected
      piiTypes
      piiOccurrences
      toxicityDetected
      toxicityScore
      toxicityCategories
      customerSatisfactionScore
      customerSatisfactionFeedback
      requestCompleted
      requestCompletionScore
      escalationRequired
      escalationReason
      qualityScore
      qualityNotes
      customAnalytics
      planMode
      planFile
      askBeforeExec
      planStatus
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listChats = /* GraphQL */ `
  query ListChats(
    $filter: ModelChatFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChats(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        name
        description
        status {
          status
          lastUpdated
        }
        workspaceID
        creationTime
        createdBy
        updatedBy
        visibility
        isAIReplying
        activeMessageForAI
        messages {
          nextToken
          startedAt
        }
        chatHistory
        topics
        documentId
        primaryRole
        primaryAgent
        plannerAgent
        forcePlannerStop
        allowMultipleRoles
        handedOffToHuman
        roles
        language
        summary
        caseId
        customerId
        caseInfo
        customerInfo
        projectId
        projectInfo
        genericEntityId
        genericEntityInfo
        metadata
        userFeedbackOnSteps
        channelSettings
        sourceJobID
        canvasID
        canvasOperations
        canvasLastChangesetID
        canvasLastChangesetTimestamp
        externalParticipantId
        piiDetected
        piiTypes
        piiOccurrences
        toxicityDetected
        toxicityScore
        toxicityCategories
        customerSatisfactionScore
        customerSatisfactionFeedback
        requestCompleted
        requestCompletionScore
        escalationRequired
        escalationReason
        qualityScore
        qualityNotes
        customAnalytics
        planMode
        planFile
        askBeforeExec
        planStatus
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncChats = /* GraphQL */ `
  query SyncChats(
    $filter: ModelChatFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncChats(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        owner
        name
        description
        status {
          status
          lastUpdated
        }
        workspaceID
        creationTime
        createdBy
        updatedBy
        visibility
        isAIReplying
        activeMessageForAI
        messages {
          nextToken
          startedAt
        }
        chatHistory
        topics
        documentId
        primaryRole
        primaryAgent
        plannerAgent
        forcePlannerStop
        allowMultipleRoles
        handedOffToHuman
        roles
        language
        summary
        caseId
        customerId
        caseInfo
        customerInfo
        projectId
        projectInfo
        genericEntityId
        genericEntityInfo
        metadata
        userFeedbackOnSteps
        channelSettings
        sourceJobID
        canvasID
        canvasOperations
        canvasLastChangesetID
        canvasLastChangesetTimestamp
        externalParticipantId
        piiDetected
        piiTypes
        piiOccurrences
        toxicityDetected
        toxicityScore
        toxicityCategories
        customerSatisfactionScore
        customerSatisfactionFeedback
        requestCompleted
        requestCompletionScore
        escalationRequired
        escalationReason
        qualityScore
        qualityNotes
        customAnalytics
        planMode
        planFile
        askBeforeExec
        planStatus
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const chatsByWorkspace = /* GraphQL */ `
  query ChatsByWorkspace(
    $workspaceID: ID!
    $creationTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChatFilterInput
    $limit: Int
    $nextToken: String
  ) {
    chatsByWorkspace(
      workspaceID: $workspaceID
      creationTime: $creationTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        name
        description
        status {
          status
          lastUpdated
        }
        workspaceID
        creationTime
        createdBy
        updatedBy
        visibility
        isAIReplying
        activeMessageForAI
        messages {
          nextToken
          startedAt
        }
        chatHistory
        topics
        documentId
        primaryRole
        primaryAgent
        plannerAgent
        forcePlannerStop
        allowMultipleRoles
        handedOffToHuman
        roles
        language
        summary
        caseId
        customerId
        caseInfo
        customerInfo
        projectId
        projectInfo
        genericEntityId
        genericEntityInfo
        metadata
        userFeedbackOnSteps
        channelSettings
        sourceJobID
        canvasID
        canvasOperations
        canvasLastChangesetID
        canvasLastChangesetTimestamp
        externalParticipantId
        piiDetected
        piiTypes
        piiOccurrences
        toxicityDetected
        toxicityScore
        toxicityCategories
        customerSatisfactionScore
        customerSatisfactionFeedback
        requestCompleted
        requestCompletionScore
        escalationRequired
        escalationReason
        qualityScore
        qualityNotes
        customAnalytics
        planMode
        planFile
        askBeforeExec
        planStatus
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const chatByExternalParticipantId = /* GraphQL */ `
  query ChatByExternalParticipantId(
    $externalParticipantId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelChatFilterInput
    $limit: Int
    $nextToken: String
  ) {
    chatByExternalParticipantId(
      externalParticipantId: $externalParticipantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        name
        description
        status {
          status
          lastUpdated
        }
        workspaceID
        creationTime
        createdBy
        updatedBy
        visibility
        isAIReplying
        activeMessageForAI
        messages {
          nextToken
          startedAt
        }
        chatHistory
        topics
        documentId
        primaryRole
        primaryAgent
        plannerAgent
        forcePlannerStop
        allowMultipleRoles
        handedOffToHuman
        roles
        language
        summary
        caseId
        customerId
        caseInfo
        customerInfo
        projectId
        projectInfo
        genericEntityId
        genericEntityInfo
        metadata
        userFeedbackOnSteps
        channelSettings
        sourceJobID
        canvasID
        canvasOperations
        canvasLastChangesetID
        canvasLastChangesetTimestamp
        externalParticipantId
        piiDetected
        piiTypes
        piiOccurrences
        toxicityDetected
        toxicityScore
        toxicityCategories
        customerSatisfactionScore
        customerSatisfactionFeedback
        requestCompleted
        requestCompletionScore
        escalationRequired
        escalationReason
        qualityScore
        qualityNotes
        customAnalytics
        planMode
        planFile
        askBeforeExec
        planStatus
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getCustomPrompt = /* GraphQL */ `
  query GetCustomPrompt($id: ID!) {
    getCustomPrompt(id: $id) {
      id
      type
      scope
      style
      domain
      label
      promptLength
      promptPlaceholder
      interpolationString
      availableToAgents
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listCustomPrompts = /* GraphQL */ `
  query ListCustomPrompts(
    $filter: ModelCustomPromptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomPrompts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        scope
        style
        domain
        label
        promptLength
        promptPlaceholder
        interpolationString
        availableToAgents
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncCustomPrompts = /* GraphQL */ `
  query SyncCustomPrompts(
    $filter: ModelCustomPromptFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCustomPrompts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        type
        scope
        style
        domain
        label
        promptLength
        promptPlaceholder
        interpolationString
        availableToAgents
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const customPromptsByWorkspace = /* GraphQL */ `
  query CustomPromptsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCustomPromptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customPromptsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        scope
        style
        domain
        label
        promptLength
        promptPlaceholder
        interpolationString
        availableToAgents
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getCronJob = /* GraphQL */ `
  query GetCronJob($id: ID!) {
    getCronJob(id: $id) {
      id
      name
      description
      forcedPrompt
      type
      routineConfig {
        maxPlannedActions
      }
      agentID
      customPromptID
      workspaceID
      schedule {
        frequency
        interval
        cronExpression
        dayOfWeek
        dayOfMonth
        hour
        minute
        startDate
        endDate
      }
      timezone
      isActive
      lastRunAt
      nextRunAt
      status
      executionConfig {
        timeout
        maxDuration
        priority
        inputParameters
        outputFormat
        webhookUrl
        webhookHeaders
      }
      notificationConfig {
        onSuccess
        onFailure
        onStart
        emailRecipients
        communicationServiceID
      }
      retryConfig {
        maxRetries
        retryInterval
        backoffMultiplier
        maxRetryInterval
      }
      metadata
      startDate
      endDate
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listCronJobs = /* GraphQL */ `
  query ListCronJobs(
    $filter: ModelCronJobFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCronJobs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        forcedPrompt
        type
        routineConfig {
          maxPlannedActions
        }
        agentID
        customPromptID
        workspaceID
        schedule {
          frequency
          interval
          cronExpression
          dayOfWeek
          dayOfMonth
          hour
          minute
          startDate
          endDate
        }
        timezone
        isActive
        lastRunAt
        nextRunAt
        status
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        metadata
        startDate
        endDate
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncCronJobs = /* GraphQL */ `
  query SyncCronJobs(
    $filter: ModelCronJobFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCronJobs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        forcedPrompt
        type
        routineConfig {
          maxPlannedActions
        }
        agentID
        customPromptID
        workspaceID
        schedule {
          frequency
          interval
          cronExpression
          dayOfWeek
          dayOfMonth
          hour
          minute
          startDate
          endDate
        }
        timezone
        isActive
        lastRunAt
        nextRunAt
        status
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        metadata
        startDate
        endDate
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const cronJobsByAgent = /* GraphQL */ `
  query CronJobsByAgent(
    $agentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCronJobFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cronJobsByAgent(
      agentID: $agentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        forcedPrompt
        type
        routineConfig {
          maxPlannedActions
        }
        agentID
        customPromptID
        workspaceID
        schedule {
          frequency
          interval
          cronExpression
          dayOfWeek
          dayOfMonth
          hour
          minute
          startDate
          endDate
        }
        timezone
        isActive
        lastRunAt
        nextRunAt
        status
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        metadata
        startDate
        endDate
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const cronJobsByPrompt = /* GraphQL */ `
  query CronJobsByPrompt(
    $customPromptID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCronJobFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cronJobsByPrompt(
      customPromptID: $customPromptID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        forcedPrompt
        type
        routineConfig {
          maxPlannedActions
        }
        agentID
        customPromptID
        workspaceID
        schedule {
          frequency
          interval
          cronExpression
          dayOfWeek
          dayOfMonth
          hour
          minute
          startDate
          endDate
        }
        timezone
        isActive
        lastRunAt
        nextRunAt
        status
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        metadata
        startDate
        endDate
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const cronJobsByWorkspace = /* GraphQL */ `
  query CronJobsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCronJobFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cronJobsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        forcedPrompt
        type
        routineConfig {
          maxPlannedActions
        }
        agentID
        customPromptID
        workspaceID
        schedule {
          frequency
          interval
          cronExpression
          dayOfWeek
          dayOfMonth
          hour
          minute
          startDate
          endDate
        }
        timezone
        isActive
        lastRunAt
        nextRunAt
        status
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        metadata
        startDate
        endDate
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const cronJobsByNextRun = /* GraphQL */ `
  query CronJobsByNextRun(
    $nextRunAt: AWSDateTime!
    $workspaceID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCronJobFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cronJobsByNextRun(
      nextRunAt: $nextRunAt
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        forcedPrompt
        type
        routineConfig {
          maxPlannedActions
        }
        agentID
        customPromptID
        workspaceID
        schedule {
          frequency
          interval
          cronExpression
          dayOfWeek
          dayOfMonth
          hour
          minute
          startDate
          endDate
        }
        timezone
        isActive
        lastRunAt
        nextRunAt
        status
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        metadata
        startDate
        endDate
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getTrigger = /* GraphQL */ `
  query GetTrigger($id: ID!) {
    getTrigger(id: $id) {
      id
      name
      description
      agentID
      customPromptID
      forcedPrompt
      eventSourceType
      eventConfig
      isActive
      status
      lastTriggeredAt
      lastEventID
      triggerCount
      executionConfig {
        timeout
        maxDuration
        priority
        inputParameters
        outputFormat
        webhookUrl
        webhookHeaders
      }
      notificationConfig {
        onSuccess
        onFailure
        onStart
        emailRecipients
        communicationServiceID
      }
      retryConfig {
        maxRetries
        retryInterval
        backoffMultiplier
        maxRetryInterval
      }
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      metadata
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listTriggers = /* GraphQL */ `
  query ListTriggers(
    $filter: ModelTriggerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTriggers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        agentID
        customPromptID
        forcedPrompt
        eventSourceType
        eventConfig
        isActive
        status
        lastTriggeredAt
        lastEventID
        triggerCount
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        metadata
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncTriggers = /* GraphQL */ `
  query SyncTriggers(
    $filter: ModelTriggerFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTriggers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        agentID
        customPromptID
        forcedPrompt
        eventSourceType
        eventConfig
        isActive
        status
        lastTriggeredAt
        lastEventID
        triggerCount
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        metadata
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const triggersByAgent = /* GraphQL */ `
  query TriggersByAgent(
    $agentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTriggerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    triggersByAgent(
      agentID: $agentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        agentID
        customPromptID
        forcedPrompt
        eventSourceType
        eventConfig
        isActive
        status
        lastTriggeredAt
        lastEventID
        triggerCount
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        metadata
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const triggersByPrompt = /* GraphQL */ `
  query TriggersByPrompt(
    $customPromptID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTriggerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    triggersByPrompt(
      customPromptID: $customPromptID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        agentID
        customPromptID
        forcedPrompt
        eventSourceType
        eventConfig
        isActive
        status
        lastTriggeredAt
        lastEventID
        triggerCount
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        metadata
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const triggersByWorkspace = /* GraphQL */ `
  query TriggersByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTriggerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    triggersByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        agentID
        customPromptID
        forcedPrompt
        eventSourceType
        eventConfig
        isActive
        status
        lastTriggeredAt
        lastEventID
        triggerCount
        executionConfig {
          timeout
          maxDuration
          priority
          inputParameters
          outputFormat
          webhookUrl
          webhookHeaders
        }
        notificationConfig {
          onSuccess
          onFailure
          onStart
          emailRecipients
          communicationServiceID
        }
        retryConfig {
          maxRetries
          retryInterval
          backoffMultiplier
          maxRetryInterval
        }
        workspaceID
        createdBy
        updatedBy
        createdAt
        updatedAt
        metadata
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getCustomCodeExecutionEnvironment = /* GraphQL */ `
  query GetCustomCodeExecutionEnvironment($id: ID!) {
    getCustomCodeExecutionEnvironment(id: $id) {
      id
      name
      description
      functionName
      availableLibraries
      customExecutionInstructions
      customExecutionCode
      customExecutionSecrets
      staticDocs
      staticArtifacts
      allowExternalAPI
      hardcodedScript
      isTemplate
      workspaceID
      createdBy
      updatedBy
      customCodeExecutionEnvironmentVersion
      customCodeExecutionEnvironmentType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listCustomCodeExecutionEnvironments = /* GraphQL */ `
  query ListCustomCodeExecutionEnvironments(
    $filter: ModelCustomCodeExecutionEnvironmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomCodeExecutionEnvironments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        functionName
        availableLibraries
        customExecutionInstructions
        customExecutionCode
        customExecutionSecrets
        staticDocs
        staticArtifacts
        allowExternalAPI
        hardcodedScript
        isTemplate
        workspaceID
        createdBy
        updatedBy
        customCodeExecutionEnvironmentVersion
        customCodeExecutionEnvironmentType
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncCustomCodeExecutionEnvironments = /* GraphQL */ `
  query SyncCustomCodeExecutionEnvironments(
    $filter: ModelCustomCodeExecutionEnvironmentFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCustomCodeExecutionEnvironments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        functionName
        availableLibraries
        customExecutionInstructions
        customExecutionCode
        customExecutionSecrets
        staticDocs
        staticArtifacts
        allowExternalAPI
        hardcodedScript
        isTemplate
        workspaceID
        createdBy
        updatedBy
        customCodeExecutionEnvironmentVersion
        customCodeExecutionEnvironmentType
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const customCodeExecutionEnvironmentsByWorkspace = /* GraphQL */ `
  query CustomCodeExecutionEnvironmentsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCustomCodeExecutionEnvironmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customCodeExecutionEnvironmentsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        functionName
        availableLibraries
        customExecutionInstructions
        customExecutionCode
        customExecutionSecrets
        staticDocs
        staticArtifacts
        allowExternalAPI
        hardcodedScript
        isTemplate
        workspaceID
        createdBy
        updatedBy
        customCodeExecutionEnvironmentVersion
        customCodeExecutionEnvironmentType
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getChatMessage = /* GraphQL */ `
  query GetChatMessage($id: ID!) {
    getChatMessage(id: $id) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listChatMessages = /* GraphQL */ `
  query ListChatMessages(
    $filter: ModelChatMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChatMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        role
        chatID
        text
        t_text
        t_text_summary
        createdAt
        creationTime
        updatedAt
        scoring
        embeddingId
        humanFeedback
        humanFeedbackComment
        humanFeedbackType
        humanFeedbackSubType
        humanFeedbackProvidedBy
        adminResolution
        prevMessage
        prevMessagePosEq
        prevMessageNegEq
        correctContext
        correctAnswer
        adminChecked
        autoTune
        userID
        agentID
        humanFeedbackForInstruction
        images
        audios
        videos
        files
        imagesText
        audiosText
        videosText
        filesText
        isAI
        messageType
        status
        metadata
        callbackMetadata
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncChatMessages = /* GraphQL */ `
  query SyncChatMessages(
    $filter: ModelChatMessageFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncChatMessages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        role
        chatID
        text
        t_text
        t_text_summary
        createdAt
        creationTime
        updatedAt
        scoring
        embeddingId
        humanFeedback
        humanFeedbackComment
        humanFeedbackType
        humanFeedbackSubType
        humanFeedbackProvidedBy
        adminResolution
        prevMessage
        prevMessagePosEq
        prevMessageNegEq
        correctContext
        correctAnswer
        adminChecked
        autoTune
        userID
        agentID
        humanFeedbackForInstruction
        images
        audios
        videos
        files
        imagesText
        audiosText
        videosText
        filesText
        isAI
        messageType
        status
        metadata
        callbackMetadata
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const messagesByChat = /* GraphQL */ `
  query MessagesByChat(
    $chatID: ID!
    $creationTime: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChatMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByChat(
      chatID: $chatID
      creationTime: $creationTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        role
        chatID
        text
        t_text
        t_text_summary
        createdAt
        creationTime
        updatedAt
        scoring
        embeddingId
        humanFeedback
        humanFeedbackComment
        humanFeedbackType
        humanFeedbackSubType
        humanFeedbackProvidedBy
        adminResolution
        prevMessage
        prevMessagePosEq
        prevMessageNegEq
        correctContext
        correctAnswer
        adminChecked
        autoTune
        userID
        agentID
        humanFeedbackForInstruction
        images
        audios
        videos
        files
        imagesText
        audiosText
        videosText
        filesText
        isAI
        messageType
        status
        metadata
        callbackMetadata
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const messagesByAgent = /* GraphQL */ `
  query MessagesByAgent(
    $agentID: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChatMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByAgent(
      agentID: $agentID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        role
        chatID
        text
        t_text
        t_text_summary
        createdAt
        creationTime
        updatedAt
        scoring
        embeddingId
        humanFeedback
        humanFeedbackComment
        humanFeedbackType
        humanFeedbackSubType
        humanFeedbackProvidedBy
        adminResolution
        prevMessage
        prevMessagePosEq
        prevMessageNegEq
        correctContext
        correctAnswer
        adminChecked
        autoTune
        userID
        agentID
        humanFeedbackForInstruction
        images
        audios
        videos
        files
        imagesText
        audiosText
        videosText
        filesText
        isAI
        messageType
        status
        metadata
        callbackMetadata
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const messagesByWorkspace = /* GraphQL */ `
  query MessagesByWorkspace(
    $workspaceID: ID!
    $humanFeedback: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChatMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByWorkspace(
      workspaceID: $workspaceID
      humanFeedback: $humanFeedback
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        role
        chatID
        text
        t_text
        t_text_summary
        createdAt
        creationTime
        updatedAt
        scoring
        embeddingId
        humanFeedback
        humanFeedbackComment
        humanFeedbackType
        humanFeedbackSubType
        humanFeedbackProvidedBy
        adminResolution
        prevMessage
        prevMessagePosEq
        prevMessageNegEq
        correctContext
        correctAnswer
        adminChecked
        autoTune
        userID
        agentID
        humanFeedbackForInstruction
        images
        audios
        videos
        files
        imagesText
        audiosText
        videosText
        filesText
        isAI
        messageType
        status
        metadata
        callbackMetadata
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getCommunicationService = /* GraphQL */ `
  query GetCommunicationService($id: ID!) {
    getCommunicationService(id: $id) {
      id
      workspaceID
      name
      description
      channel
      provider
      senderid
      fromNumber
      tokenSecret
      sipTrunkId
      isActive
      config
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listCommunicationServices = /* GraphQL */ `
  query ListCommunicationServices(
    $filter: ModelCommunicationServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommunicationServices(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        workspaceID
        name
        description
        channel
        provider
        senderid
        fromNumber
        tokenSecret
        sipTrunkId
        isActive
        config
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncCommunicationServices = /* GraphQL */ `
  query SyncCommunicationServices(
    $filter: ModelCommunicationServiceFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCommunicationServices(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        workspaceID
        name
        description
        channel
        provider
        senderid
        fromNumber
        tokenSecret
        sipTrunkId
        isActive
        config
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const communicationServicesByWorkspace = /* GraphQL */ `
  query CommunicationServicesByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCommunicationServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    CommunicationServicesByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        workspaceID
        name
        description
        channel
        provider
        senderid
        fromNumber
        tokenSecret
        sipTrunkId
        isActive
        config
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getSubscriptionPricingPlan = /* GraphQL */ `
  query GetSubscriptionPricingPlan($id: ID!) {
    getSubscriptionPricingPlan(id: $id) {
      id
      type
      subscriptionStatus
      isPredictionOnDemandGlobal
      isTrainingOnDemandGlobal
      predictionRequestsGlobal
      batchRequestsGlobal
      trainingMinutesGlobal
      baseModelGN
      baseModelQA
      baseModelNLP
      maxUsers
      maxPowerUsers
      agcEnabled
      isDownloadModelEnabled
      isDownloadDataEnabled
      isAPIAccessEnabled
      isBatchJobsEnabled
      isSentimentReviewerEnabled
      isBusinessAnalystEnabled
      isContentCreatorEnabled
      isPriorityTrainingEnabled
      isPredictionGPUAccelerationEnabledGlobal
      isPredictionGPUAccelerationEnabledRC
      isPredictionGPUAccelerationEnabledNLP
      aiMaxConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      maxMrcDocs
      maxAgents
      maxSites
      maxBenchmarks
      predictionRequestsAPI
      accuracyModelEnabled
      isTrainingNLPEnabled
      isTrainingQAEnabled
      isTrainingGNEnabled
      isLongTermMemoryEnabled
      isFunctionsEnabled
      isDBFunctionsEnabled
      isHtmlFunctionsEnabled
      isSitesBindingEnabled
      isAgentsSecurityEnabled
      isWidgetChatsHistoryEnabled
      maxRequests30Minutes
      maxRequests24Hours
      defaultSupportHours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listSubscriptionPricingPlans = /* GraphQL */ `
  query ListSubscriptionPricingPlans(
    $filter: ModelSubscriptionPricingPlanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionPricingPlans(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        subscriptionStatus
        isPredictionOnDemandGlobal
        isTrainingOnDemandGlobal
        predictionRequestsGlobal
        batchRequestsGlobal
        trainingMinutesGlobal
        baseModelGN
        baseModelQA
        baseModelNLP
        maxUsers
        maxPowerUsers
        agcEnabled
        isDownloadModelEnabled
        isDownloadDataEnabled
        isAPIAccessEnabled
        isBatchJobsEnabled
        isSentimentReviewerEnabled
        isBusinessAnalystEnabled
        isContentCreatorEnabled
        isPriorityTrainingEnabled
        isPredictionGPUAccelerationEnabledGlobal
        isPredictionGPUAccelerationEnabledRC
        isPredictionGPUAccelerationEnabledNLP
        aiMaxConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        maxMrcDocs
        maxAgents
        maxSites
        maxBenchmarks
        predictionRequestsAPI
        accuracyModelEnabled
        isTrainingNLPEnabled
        isTrainingQAEnabled
        isTrainingGNEnabled
        isLongTermMemoryEnabled
        isFunctionsEnabled
        isDBFunctionsEnabled
        isHtmlFunctionsEnabled
        isSitesBindingEnabled
        isAgentsSecurityEnabled
        isWidgetChatsHistoryEnabled
        maxRequests30Minutes
        maxRequests24Hours
        defaultSupportHours
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncSubscriptionPricingPlans = /* GraphQL */ `
  query SyncSubscriptionPricingPlans(
    $filter: ModelSubscriptionPricingPlanFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubscriptionPricingPlans(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        type
        subscriptionStatus
        isPredictionOnDemandGlobal
        isTrainingOnDemandGlobal
        predictionRequestsGlobal
        batchRequestsGlobal
        trainingMinutesGlobal
        baseModelGN
        baseModelQA
        baseModelNLP
        maxUsers
        maxPowerUsers
        agcEnabled
        isDownloadModelEnabled
        isDownloadDataEnabled
        isAPIAccessEnabled
        isBatchJobsEnabled
        isSentimentReviewerEnabled
        isBusinessAnalystEnabled
        isContentCreatorEnabled
        isPriorityTrainingEnabled
        isPredictionGPUAccelerationEnabledGlobal
        isPredictionGPUAccelerationEnabledRC
        isPredictionGPUAccelerationEnabledNLP
        aiMaxConsumption {
          lastUpdate
          requestsLast30Minutes
          requestsLast24Hours
          totalUoI
          totalCostUSD
          familyBudgetUoI
          familyMaxUsers
          childrenCount
          cachedInputTokens
          cacheSavingsUSD
        }
        maxMrcDocs
        maxAgents
        maxSites
        maxBenchmarks
        predictionRequestsAPI
        accuracyModelEnabled
        isTrainingNLPEnabled
        isTrainingQAEnabled
        isTrainingGNEnabled
        isLongTermMemoryEnabled
        isFunctionsEnabled
        isDBFunctionsEnabled
        isHtmlFunctionsEnabled
        isSitesBindingEnabled
        isAgentsSecurityEnabled
        isWidgetChatsHistoryEnabled
        maxRequests30Minutes
        maxRequests24Hours
        defaultSupportHours
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getVoucher = /* GraphQL */ `
  query GetVoucher($id: ID!) {
    getVoucher(id: $id) {
      id
      name
      description
      code
      amount
      currency
      startDate
      endDate
      status
      type
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listVouchers = /* GraphQL */ `
  query ListVouchers(
    $filter: ModelVoucherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVouchers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        code
        amount
        currency
        startDate
        endDate
        status
        type
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncVouchers = /* GraphQL */ `
  query SyncVouchers(
    $filter: ModelVoucherFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncVouchers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        code
        amount
        currency
        startDate
        endDate
        status
        type
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const voucherByCode = /* GraphQL */ `
  query VoucherByCode(
    $code: String!
    $sortDirection: ModelSortDirection
    $filter: ModelVoucherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    voucherByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        code
        amount
        currency
        startDate
        endDate
        status
        type
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getVoucherRedemption = /* GraphQL */ `
  query GetVoucherRedemption($id: ID!) {
    getVoucherRedemption(id: $id) {
      id
      voucherID
      userID
      workspaceID
      redeemedAt
      appliedAmount
      appliedCurrency
      orderID
      metadata
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listVoucherRedemptions = /* GraphQL */ `
  query ListVoucherRedemptions(
    $filter: ModelVoucherRedemptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVoucherRedemptions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        voucherID
        userID
        workspaceID
        redeemedAt
        appliedAmount
        appliedCurrency
        orderID
        metadata
        createdBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncVoucherRedemptions = /* GraphQL */ `
  query SyncVoucherRedemptions(
    $filter: ModelVoucherRedemptionFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncVoucherRedemptions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        voucherID
        userID
        workspaceID
        redeemedAt
        appliedAmount
        appliedCurrency
        orderID
        metadata
        createdBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const redemptionsByVoucher = /* GraphQL */ `
  query RedemptionsByVoucher(
    $voucherID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVoucherRedemptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    redemptionsByVoucher(
      voucherID: $voucherID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        voucherID
        userID
        workspaceID
        redeemedAt
        appliedAmount
        appliedCurrency
        orderID
        metadata
        createdBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const redemptionsByUser = /* GraphQL */ `
  query RedemptionsByUser(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVoucherRedemptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    redemptionsByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        voucherID
        userID
        workspaceID
        redeemedAt
        appliedAmount
        appliedCurrency
        orderID
        metadata
        createdBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const redemptionsByWorkspace = /* GraphQL */ `
  query RedemptionsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelVoucherRedemptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    redemptionsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        voucherID
        userID
        workspaceID
        redeemedAt
        appliedAmount
        appliedCurrency
        orderID
        metadata
        createdBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getSubscriptionBaseConfig = /* GraphQL */ `
  query GetSubscriptionBaseConfig($id: ID!) {
    getSubscriptionBaseConfig(id: $id) {
      id
      type
      planConfig {
        domain
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listSubscriptionBaseConfigs = /* GraphQL */ `
  query ListSubscriptionBaseConfigs(
    $filter: ModelSubscriptionBaseConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionBaseConfigs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        planConfig {
          domain
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncSubscriptionBaseConfigs = /* GraphQL */ `
  query SyncSubscriptionBaseConfigs(
    $filter: ModelSubscriptionBaseConfigFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubscriptionBaseConfigs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        type
        planConfig {
          domain
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getGenerationConfig = /* GraphQL */ `
  query GetGenerationConfig($id: ID!) {
    getGenerationConfig(id: $id) {
      id
      styles
      domains
      scopes
      prompts {
        type
        label
        promptLength
        promptPlaceholder
        interpolationString
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listGenerationConfigs = /* GraphQL */ `
  query ListGenerationConfigs(
    $filter: ModelGenerationConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGenerationConfigs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncGenerationConfigs = /* GraphQL */ `
  query SyncGenerationConfigs(
    $filter: ModelGenerationConfigFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncGenerationConfigs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getArenaBattle = /* GraphQL */ `
  query GetArenaBattle($id: ID!) {
    getArenaBattle(id: $id) {
      id
      firstAgent
      secondAgent
      firstAgentChatID
      secondAgentChatID
      winnerID
      createdAt
      creationTime
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listArenaBattles = /* GraphQL */ `
  query ListArenaBattles(
    $filter: ModelArenaBattleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArenaBattles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstAgent
        secondAgent
        firstAgentChatID
        secondAgentChatID
        winnerID
        createdAt
        creationTime
        updatedAt
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncArenaBattles = /* GraphQL */ `
  query SyncArenaBattles(
    $filter: ModelArenaBattleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncArenaBattles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        firstAgent
        secondAgent
        firstAgentChatID
        secondAgentChatID
        winnerID
        createdAt
        creationTime
        updatedAt
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const arenaBattlesByWorkspace = /* GraphQL */ `
  query ArenaBattlesByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelArenaBattleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ArenaBattlesByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstAgent
        secondAgent
        firstAgentChatID
        secondAgentChatID
        winnerID
        createdAt
        creationTime
        updatedAt
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getBenchmark = /* GraphQL */ `
  query GetBenchmark($id: ID!) {
    getBenchmark(id: $id) {
      id
      name
      description
      questions {
        type
        question
        answer
        reasoning
        context
        images
        files
      }
      workspaceID
      createdAt
      creationTime
      updatedAt
      metadata
      files
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listBenchmarks = /* GraphQL */ `
  query ListBenchmarks(
    $filter: ModelBenchmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBenchmarks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        questions {
          type
          question
          answer
          reasoning
          context
          images
          files
        }
        workspaceID
        createdAt
        creationTime
        updatedAt
        metadata
        files
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncBenchmarks = /* GraphQL */ `
  query SyncBenchmarks(
    $filter: ModelBenchmarkFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncBenchmarks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        questions {
          type
          question
          answer
          reasoning
          context
          images
          files
        }
        workspaceID
        createdAt
        creationTime
        updatedAt
        metadata
        files
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const benchmarksByWorkspace = /* GraphQL */ `
  query BenchmarksByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBenchmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    BenchmarksByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        questions {
          type
          question
          answer
          reasoning
          context
          images
          files
        }
        workspaceID
        createdAt
        creationTime
        updatedAt
        metadata
        files
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getProject = /* GraphQL */ `
  query GetProject($id: ID!) {
    getProject(id: $id) {
      id
      name
      description
      startDate
      endDate
      status
      workspaceID
      agentID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listProjects = /* GraphQL */ `
  query ListProjects(
    $filter: ModelProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        startDate
        endDate
        status
        workspaceID
        agentID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncProjects = /* GraphQL */ `
  query SyncProjects(
    $filter: ModelProjectFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProjects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        description
        startDate
        endDate
        status
        workspaceID
        agentID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getReminder = /* GraphQL */ `
  query GetReminder($id: ID!) {
    getReminder(id: $id) {
      id
      title
      description
      workspaceID
      projectID
      status
      priority
      dueDate
      completedDate
      recurringPattern
      assignedTo
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listReminders = /* GraphQL */ `
  query ListReminders(
    $filter: ModelReminderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReminders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        workspaceID
        projectID
        status
        priority
        dueDate
        completedDate
        recurringPattern
        assignedTo
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncReminders = /* GraphQL */ `
  query SyncReminders(
    $filter: ModelReminderFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncReminders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        description
        workspaceID
        projectID
        status
        priority
        dueDate
        completedDate
        recurringPattern
        assignedTo
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const remindersByWorkspaceAndDueDate = /* GraphQL */ `
  query RemindersByWorkspaceAndDueDate(
    $workspaceID: ID!
    $dueDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReminderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    remindersByWorkspaceAndDueDate(
      workspaceID: $workspaceID
      dueDate: $dueDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        workspaceID
        projectID
        status
        priority
        dueDate
        completedDate
        recurringPattern
        assignedTo
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const remindersByProjectID = /* GraphQL */ `
  query RemindersByProjectID(
    $projectID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReminderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    remindersByProjectID(
      projectID: $projectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        workspaceID
        projectID
        status
        priority
        dueDate
        completedDate
        recurringPattern
        assignedTo
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const remindersByWorkspaceAndStatus = /* GraphQL */ `
  query RemindersByWorkspaceAndStatus(
    $status: ReminderStatus!
    $workspaceID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReminderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    remindersByWorkspaceAndStatus(
      status: $status
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        workspaceID
        projectID
        status
        priority
        dueDate
        completedDate
        recurringPattern
        assignedTo
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const remindersByWorkspaceAndAssignees = /* GraphQL */ `
  query RemindersByWorkspaceAndAssignees(
    $assignedTo: String!
    $workspaceID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReminderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    remindersByWorkspaceAndAssignees(
      assignedTo: $assignedTo
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        workspaceID
        projectID
        status
        priority
        dueDate
        completedDate
        recurringPattern
        assignedTo
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getProjectItem = /* GraphQL */ `
  query GetProjectItem($id: ID!) {
    getProjectItem(id: $id) {
      id
      title
      description
      type
      status
      priority
      dueDate
      assignee
      metadata
      projectID
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listProjectItems = /* GraphQL */ `
  query ListProjectItems(
    $filter: ModelProjectItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        type
        status
        priority
        dueDate
        assignee
        metadata
        projectID
        workspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncProjectItems = /* GraphQL */ `
  query SyncProjectItems(
    $filter: ModelProjectItemFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProjectItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        description
        type
        status
        priority
        dueDate
        assignee
        metadata
        projectID
        workspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const projectItemsByProjectID = /* GraphQL */ `
  query ProjectItemsByProjectID(
    $projectID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProjectItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    projectItemsByProjectID(
      projectID: $projectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        type
        status
        priority
        dueDate
        assignee
        metadata
        projectID
        workspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const projectItemsByWorkspace = /* GraphQL */ `
  query ProjectItemsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProjectItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    projectItemsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        type
        status
        priority
        dueDate
        assignee
        metadata
        projectID
        workspaceID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      name
      companyName
      email
      phone
      type
      status
      lifecycle
      segment
      pipeline
      lastContactDate
      nextFollowUpDate
      assignedTo
      totalRevenue
      potentialValue
      currency
      acquisitionSource
      relationshipStrength
      metadata
      notes
      createdAt
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        companyName
        email
        phone
        type
        status
        lifecycle
        segment
        pipeline
        lastContactDate
        nextFollowUpDate
        assignedTo
        totalRevenue
        potentialValue
        currency
        acquisitionSource
        relationshipStrength
        metadata
        notes
        createdAt
        updatedAt
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncCustomers = /* GraphQL */ `
  query SyncCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCustomers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        companyName
        email
        phone
        type
        status
        lifecycle
        segment
        pipeline
        lastContactDate
        nextFollowUpDate
        assignedTo
        totalRevenue
        potentialValue
        currency
        acquisitionSource
        relationshipStrength
        metadata
        notes
        createdAt
        updatedAt
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const customersByWorkspace = /* GraphQL */ `
  query CustomersByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customersByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        companyName
        email
        phone
        type
        status
        lifecycle
        segment
        pipeline
        lastContactDate
        nextFollowUpDate
        assignedTo
        totalRevenue
        potentialValue
        currency
        acquisitionSource
        relationshipStrength
        metadata
        notes
        createdAt
        updatedAt
        workspaceID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getLog = /* GraphQL */ `
  query GetLog($id: ID!) {
    getLog(id: $id) {
      id
      type
      action
      description
      metadata
      performedBy
      performedAt
      workspaceID
      projectItem
      customerItem
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listLogs = /* GraphQL */ `
  query ListLogs(
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        action
        description
        metadata
        performedBy
        performedAt
        workspaceID
        projectItem
        customerItem
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncLogs = /* GraphQL */ `
  query SyncLogs(
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        type
        action
        description
        metadata
        performedBy
        performedAt
        workspaceID
        projectItem
        customerItem
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const logsByWorkspace = /* GraphQL */ `
  query LogsByWorkspace(
    $workspaceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logsByWorkspace(
      workspaceID: $workspaceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        action
        description
        metadata
        performedBy
        performedAt
        workspaceID
        projectItem
        customerItem
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const logsByProjectItemID = /* GraphQL */ `
  query LogsByProjectItemID(
    $projectItem: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logsByProjectItemID(
      projectItem: $projectItem
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        action
        description
        metadata
        performedBy
        performedAt
        workspaceID
        projectItem
        customerItem
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const logsByCustomerID = /* GraphQL */ `
  query LogsByCustomerID(
    $customerItem: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logsByCustomerID(
      customerItem: $customerItem
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        action
        description
        metadata
        performedBy
        performedAt
        workspaceID
        projectItem
        customerItem
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getEntitySnapshot = /* GraphQL */ `
  query GetEntitySnapshot($id: ID!) {
    getEntitySnapshot(id: $id) {
      id
      workspaceID
      sortKey
      entityType
      entityID
      snapshotVersion
      snapshotData
      entityName
      ttl
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listEntitySnapshots = /* GraphQL */ `
  query ListEntitySnapshots(
    $filter: ModelEntitySnapshotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEntitySnapshots(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        workspaceID
        sortKey
        entityType
        entityID
        snapshotVersion
        snapshotData
        entityName
        ttl
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncEntitySnapshots = /* GraphQL */ `
  query SyncEntitySnapshots(
    $filter: ModelEntitySnapshotFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEntitySnapshots(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        workspaceID
        sortKey
        entityType
        entityID
        snapshotVersion
        snapshotData
        entityName
        ttl
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const snapshotsByWorkspace = /* GraphQL */ `
  query SnapshotsByWorkspace(
    $workspaceID: ID!
    $sortKey: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEntitySnapshotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    snapshotsByWorkspace(
      workspaceID: $workspaceID
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        workspaceID
        sortKey
        entityType
        entityID
        snapshotVersion
        snapshotData
        entityName
        ttl
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const snapshotsByEntity = /* GraphQL */ `
  query SnapshotsByEntity(
    $entityID: ID!
    $sortKey: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEntitySnapshotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    snapshotsByEntity(
      entityID: $entityID
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        workspaceID
        sortKey
        entityType
        entityID
        snapshotVersion
        snapshotData
        entityName
        ttl
        metadata
        createdBy
        updatedBy
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
